<template>
  <b-col lg="12">
    <b-overlay :show="show" rounded="sm">
      <modal-adicionar-itens ref="adicionar-itens-pedido" />
      <modal-editar-itens ref="editar-itens-pedido" />
      <modal-auto-completar-pedido ref="modalAutoCompletar" contexto="operacao" />
      <modal-importar-csv v-model="showImportarCsv" contexto="operacao" />
      <b-alert v-if="isPedidoDoacaoAtual && avisosBudgetCarrinho.length" show
        :variant="budgetCarrinhoBloqueia ? 'danger' : 'warning'" class="mb-1">
        <div class="alert-body">
          <feather-icon icon="AlertTriangleIcon" class="mr-50" />
          <strong>{{ budgetCarrinhoBloqueia ? 'Budget insuficiente' : 'Atenção ao budget' }}</strong>
          <div v-for="(msg, i) in avisosBudgetCarrinho" :key="`budget-${i}`" class="small mt-25">{{ msg }}</div>
          <div v-if="budgetMisto" class="small mt-25">
            Pedido único com itens ELT e GL. Cada supervisor aprova somente sua categoria; o envio ao Datasul aguarda as duas aprovações.
          </div>
        </div>
      </b-alert>
      <!-- <modal_pic_pedido ref="open_modal_pic" /> -->
      <b-col>
        <div class="demo-inline-spacing">
          <b-button class="mr-2 bg-secondary bg-darken-2 border-0" @click="voltar">
            <feather-icon icon="ArrowLeftCircleIcon" size="18" />
            Voltar
          </b-button>
          <b-button class="mr-2 bg-success bg-darken-2 border-0"
            :disabled="getListTabelaItens.length === 0 || (bloqueioPedidoMinimoAtivo && !pedidoMinimo)" @click="confirmarSalvar">
            <feather-icon icon="SaveIcon" size="18" />
            Salvar
          </b-button>
          <b-button class="mr-2 border-0" variant="outline-primary" @click="abrirAutoCompletar">
            <feather-icon icon="RepeatIcon" size="18" />
            Auto completar pedido
          </b-button>
          <b-button class="mr-2 border-0" variant="outline-primary" @click="abrirImportarCsv">
            <feather-icon icon="UploadIcon" size="18" />
            Importar via CSV
          </b-button>
          <b-button v-if="picAtivo" class="mr-2 border-0" variant="outline-success"
            :disabled="!podeBuscarPromocoes" @click="openModalPic">
            <feather-icon icon="TagIcon" size="18" />
            Ver Promoções
          </b-button>
          <small v-if="picAtivo && !podeBuscarPromocoes" class="text-muted">
            Informe cliente, estabelecimento, tabela e condição de pagamento para ver promoções.
          </small>
          <b-button v-if="rascunhoAtivo" class="mr-2 bg-darken-2 border-0" variant="outline-secondary"
            :disabled="getListTabelaItens.length === 0 || (bloqueioPedidoMinimoAtivo && !pedidoMinimo)" @click="confirmarRascunho">
            <feather-icon icon="FileTextIcon" size="18" />
            Rascunho
          </b-button>
          <!-- <b-button v-if="!isClienteFinal" class="mr-2 bg-danger bg-darken-2 border-0" @click="limparFormulario">
            <feather-icon icon="TrashIcon" size="18" />
            Limpar
          </b-button> -->
        </div>
      </b-col>
      <b-col md="12" class="mt-2">
        <b-card no-body>
          <b-card-header :header-bg-variant="`secondary bg-lighten-5`" class="w-100">
            <b-card-title>Pedido</b-card-title>
          </b-card-header>
          <b-tabs card pills nav-class="nav-pill-primary" v-model="tabAtiva">
            <b-tab>
              <template #title>
                <feather-icon icon="PocketIcon" />
                <span>Condições</span>
              </template>
              <!-- <b-alert v-if="isInfoPedidoBloqueado" show variant="warning" class="mb-3">
                <feather-icon icon="AlertTriangleIcon" class="mr-1" />
                <span>O pedido possui itens adicionados. Remova todos os itens para alterar as informações.</span>
              </b-alert> -->
              <h5 class="mb-2">
                NR Pré-Pedido
              </h5>
              <info-pedido :bloqueado="isInfoPedidoBloqueado" />
            </b-tab>
            <b-tab :disabled="isTabItensDisabled">
              <template #title>
                <feather-icon icon="ListIcon" />
                <span>Itens</span>
              </template>
              <b-alert v-if="!isPedidoDoacaoAtual" variant="warning" :show="!pedidoMinimo && getListTabelaItens.length > 0">
                <div class="alert-body">
                  <feather-icon icon="AlertTriangleIcon" class="mr-50" />
                  <span>Pedido mínimo: R${{ dadosCliente.valorMinimoPedido }}</span>
                </div>
              </b-alert>
              <b-alert variant="info" :show="getListTabelaItens.length > 0">
                <div class="alert-body">
                  <feather-icon icon="InfoIcon" class="mr-50" />
                  <span>Valor total do pedido: {{ dinheiroVisual(somaVisual(itensFlat)) }}</span>
                </div>
              </b-alert>
              <b-alert variant="primary"
                :show="!!(ultimoPedidoResumo && ultimoPedidoResumo.pedidoReferencia)"
                class="mb-2">
                <div class="alert-body d-flex flex-column flex-md-row align-items-md-center justify-content-between">
                  <div>
                    <feather-icon icon="ZapIcon" class="mr-50" />
                    <strong>Carrinho Inteligente</strong>
                    <span v-if="ultimoPedidoResumo && ultimoPedidoResumo.pedidoReferencia">
                      — Último pedido deste cliente:
                      <strong>#{{ ultimoPedidoResumo.pedidoReferencia.pedidoid }}</strong>
                      em {{ ultimoPedidoResumo.pedidoReferencia.pedidodata }}
                      ({{ ultimoPedidoResumo.totalItens }} {{ Number(ultimoPedidoResumo.totalItens) === 1 ? 'item' : 'itens' }})
                    </span>
                  </div>
                  <b-button size="sm" variant="relief-primary" class="mt-1 mt-md-0"
                    @click="abrirCatalogoCarrinhoInteligente">
                    <feather-icon icon="ShoppingBagIcon" class="mr-25" />
                    Importar via Catálogo
                  </b-button>
                </div>
              </b-alert>
              <b-col>
                <div class="demo-inline-spacing">
                  <b-button variant="success" @click="openModal">
                    <feather-icon icon="PlusIcon" size="18" />
                    Novo
                  </b-button>
                </div>
              </b-col>
              <b-col cols="12">
                <hr>
              </b-col>
              <!-- Tabela ÚNICA sintetizada (achatada): uma linha por item, sem
                   "Mostrar detalhes"/sub-tabela. itensFlat/fieldsFlat mantêm
                   somente os índices necessários para localizar o grupo. -->
              <b-table :items="itensFlat" :fields="fieldsFlat" striped responsive :striped="true" :bordered="true"
                :hover="true" v-if="itensFlat.length != 0">
                <template #cell(precoComImposto)="row">
                  {{ dinheiroVisual(precoUnitarioVisual(row.item)) }}
                </template>
                <template #cell(valorTotalComImposto)="row">
                  {{ dinheiroVisual(subtotalVisual(row.item)) }}
                </template>
                <template #cell(pedidoItemQuantidade)="subRow">
                  <div class="d-flex align-items-center justify-content-center">
                    <b-button size="sm" variant="outline-danger" class="mr-1"
                      @click="decrementQuantity({ index: subRow.item._grpIndex, item: getListTabelaItens[subRow.item._grpIndex] }, { index: subRow.item._subIndex, item: subRow.item })"
                      :disabled="!isValidDecrement(subRow)"
                      v-b-tooltip.hover :title="getMultiploTooltip(subRow)">
                      <feather-icon icon="MinusIcon" size="14" />
                    </b-button>
                    <b-form-input
                      v-model.number="subRow.item.pedidoItemQuantidade"
                      type="number"
                      min="1"
                      step="1"
                      @input="handleQuantityDirectInput({ index: subRow.item._grpIndex, item: getListTabelaItens[subRow.item._grpIndex] }, { index: subRow.item._subIndex, item: subRow.item }, $event)"
                      @blur="validateQuantityOnBlur({ index: subRow.item._grpIndex, item: getListTabelaItens[subRow.item._grpIndex] }, { index: subRow.item._subIndex, item: subRow.item })"
                      @keydown="preventInvalidInput"
                      class="mx-1 text-center"
                      style="width: 70px; padding: 2px 5px;"
                    />
                    <b-button size="sm" variant="outline-success" class="ml-1"
                      @click="incrementQuantity({ index: subRow.item._grpIndex, item: getListTabelaItens[subRow.item._grpIndex] }, { index: subRow.item._subIndex, item: subRow.item })"
                      :disabled="!isValidIncrement(subRow)" v-b-tooltip.hover :title="getMultiploTooltip(subRow)">
                      <feather-icon icon="PlusIcon" size="14" />
                    </b-button>
                  </div>
                </template>
                <template #cell(excluir)="subRow">
                  <b-button size="sm" variant="outline-danger"
                    @click="removeSubItem({ index: subRow.item._grpIndex, item: getListTabelaItens[subRow.item._grpIndex] }, subRow.item._subIndex)">
                    <feather-icon icon="TrashIcon" />
                  </b-button>
                </template>
                <template #cell(promo)="row">
                  <b-badge :variant="row.item._tipoPedido === 'pic' ? 'light-success' : 'light-primary'">
                    {{ row.item._tipoPedido === 'pic' ? 'Promoção' : 'Normal' }}
                    <feather-icon icon="TagIcon" v-if="row.item._tipoPedido === 'pic'" />
                  </b-badge>
                </template>
              </b-table>
            </b-tab>
            <b-tab>
              <template #title>
                <feather-icon icon="TruckIcon" />
                <span>Entrega</span>
              </template>
              <b-row>
                <b-col md="2" v-if="$store.getters['preferencias/exibirDataPrevistaEntrega'] !== false">
                  <b-form-group label="Data Estimada Entrega">
                    <b-form-input type="date" placeholder=""
                      :value="dataEntregaPadrao"
                      :min="todayISO" @input="handleDateChange($event)" />
                  </b-form-group>
                </b-col>
                <b-col md="3">
                  <b-form-group label="Endereço">
                    <b-form-input type="text" placeholder="" v-model="formInfoPedido.enderecoEntrega.clienteendereco"
                      disabled />
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <b-form-group label="CEP">
                    <b-form-input type="number" placeholder=""
                      v-model="formInfoPedido.enderecoEntrega.clienteenderecocep" disabled />
                  </b-form-group>
                </b-col>

                <b-col md="2">
                  <b-form-group label="Bairro">
                    <b-form-input type="text" placeholder=""
                      v-model="formInfoPedido.enderecoEntrega.clienteenderecobairro" disabled />
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <b-form-group label="Cidade">
                    <b-form-input type="text" placeholder=""
                      v-model="formInfoPedido.enderecoEntrega.clienteenderecocidade" disabled />
                  </b-form-group>
                </b-col>
                <b-col md="1">
                  <b-form-group label="Estado">
                    <b-form-input type="text" placeholder="" v-model="formInfoPedido.enderecoEntrega.ufid" disabled />
                  </b-form-group>
                </b-col>
              </b-row>
              <!-- Endereço de entrega alternativo (mesma UF; busca por CEP) -->
              <escolher-endereco-entrega
                v-if="isPedidoDoacaoAtual"
                ref="escolherEnderecoEntrega"
                v-model="enderecoAlternativo"
                :clienteid="(formInfoPedido.enderecoEntrega && formInfoPedido.enderecoEntrega.clienteid) || (dadosCliente && dadosCliente.cliente && dadosCliente.cliente.clienteid)"
                :uf-atual="String((formInfoPedido.enderecoEntrega && formInfoPedido.enderecoEntrega.ufid) || '').trim()"
                class="mt-50"
                @input="onEnderecoAlternativoInput"
                @fechado="onEnderecoAlternativoFechado"
              />
              <!-- Transporte é uma informação opcional exclusiva de doação (WD). -->
              <b-row v-if="isPedidoDoacaoAtual" class="mt-50">
                <b-col cols="12" md="4">
                  <select-transporte
                    ref="selectTransporte"
                    v-model="transporteId"
                    invalid-feedback="Selecione o tipo de transporte (PAC, SEDEX ou RETIRA)."
                  />
                </b-col>
              </b-row>
            </b-tab>
          </b-tabs>
          <b-form-checkbox v-if="exibirBoletoPara15Dias" v-model="boletoPara15Dias" :disabled="pagamentoAVistaSelecionado" class="mt-1">
            Boleto para 15 dias
          </b-form-checkbox>
          <pagamento-a-vista-visual
            v-if="exibirBoletoPara15Dias"
            ref="pagamentoAVistaVisual"
            :disabled="boletoPara15Dias"
            @change="pagamentoAVistaSelecionado = $event"
            :total="Number(getTotalPedido)"
            :valor-minimo="Number(dadosCliente.valorMinimoPedido || 0)"
          />
        </b-card>
      </b-col>
    </b-overlay>
  </b-col>
</template>

<script>
import { podeSelecionarFormaPagamento } from '@/libs/perfilCliente';
import precoVisualizacaoMixin from './modal/precoVisualizacao.mixin';
import {
  BTabs,
  BTab,
  BCardText,
  BCard,
  BCol,
  BCardHeader,
  BFormSelect,
  BFormInput,
  BRow,
  BSpinner,
  BFormGroup, BButton, BTable, BFormCheckbox, BCardFooter, BAlert,
} from 'bootstrap-vue';
import { required } from '@core/utils/validations/validations';
import { mapActions, mapGetters } from 'vuex';
import { isPedidoDoacao, isPerfilClienteAtivo } from '@/libs/perfilCliente';
import BudgetClient from '@/api/Budget/budget.client';
import { itensBudgetOperacao } from '@/utils/budgetCarrinhoItens';
import { finalizarPedidoOperacaoConfirmado } from '@/utils/finalizarPedidoOperacao';
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue';
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue';
import ModalAdicionarItens from '@/views/app/operacoes/pedidosVendas/modal/modalAdicionarItens.vue';
import SLSRepresentanteService from '@/services/Cadastros/ApoioVendas/SLSRepresentante.service';
import SLSClienteService from '@/services/Cadastros/Cliente/SLSCliente.service';
import SLSEsPrioriService from '@/services/SistemaDKP/SLSEsPriori.service';
import SLSCondicaoPagamentoService from '@/services/SistemaDKP/SLSCondicaoPagamento.service';
import Swal from 'sweetalert2';
import { formtPriceBr } from '@core/utils/filter';
import SLSPedidosService from '@/services/Operacoes/SLSPedidos.service';
import SLSTabelaPrecoService from '@/services/SistemaDKP/SLSTabelapreco.service';
import modal_pic_pedido from '@/components/modal/modal_pic_pedido.vue';
import ToastificationContent from '@/@core/components/toastification/ToastificationContent.vue';
import InfoPedido from '@/components/catalogo-produtos/InfoPedido.vue';
import SLSPicService from '@/services/Operacoes/SLSPic.service';
import ModalEditarItens from '@/views/app/operacoes/pedidosVendas/modal/modalEditarItens.vue';
import EscolherEnderecoEntrega from '@/components/pedidos/EscolherEnderecoEntrega.vue';
import SelectTransporte from '@/components/pedidos/SelectTransporte.vue';
import PagamentoAVistaVisual from '@/components/pedidos/PagamentoAVistaVisual.vue';
import { getParametro } from '@/utils/totvsApi';
import { exigirEnderecoEntrega, enderecoEntregaValido } from '@/utils/impostoSimulador';
import { selecionarNaturezaFiscal } from '@/utils/naturezaFiscal';
import SLSAdocaoClient from '@/api/Operacoes/sls-adocao.client';
import SLSEstoqueService from '@/services/SistemaDKP/SLSEstoque.service';
import ModalAutoCompletarPedido from '@/components/modal/ModalAutoCompletarPedido.vue';
import ModalImportarCsv from '@/views/home/components/ModalImportarCsv.vue';
import { calcularImpostosPic } from '@/services/Operacoes/picImpostos';

const slsRepresentanteService = new SLSRepresentanteService();
const slsClienteService = new SLSClienteService();
const slsEsPrioriService = new SLSEsPrioriService();
const slsPedidosService = new SLSPedidosService();
const slsCondicaoPagamentoService = new SLSCondicaoPagamentoService();
const slsTabelapreco = new SLSTabelaPrecoService();

const picService = new SLSPicService();
const budgetClient = new BudgetClient();
export default {
  mixins: [precoVisualizacaoMixin],
  components: {
    BAlert,
    EscolherEnderecoEntrega,
    SelectTransporte,
    PagamentoAVistaVisual,
    ModalEditarItens,
    modal_pic_pedido,
    ModalAdicionarItens,
    ModalAutoCompletarPedido,
    ModalImportarCsv,
    BCardFooter,
    BButton,
    BFormGroup,
    BRow,
    BFormInput,
    BFormSelect,
    BCardHeader,
    BCol,
    BCard,
    BCardText,
    BTabs,
    BTab,
    BSpinner,
    BTable,
    BFormCheckbox,
    AppCollapse,
    AppCollapseItem,
    InfoPedido,
  },
  filters: {
    formtPriceBr,
  },
  data: () => ({
    // Endereço de entrega alternativo escolhido (null = padrão do cliente)
    enderecoAlternativo: null,
    // Cópia usada para restaurar o endereço cadastrado ao sair de WD.
    enderecoEntregaPadrao: null,
    // Sincroniza endereço alternativo escolhido fora desta tela (ex.: home /
    // ModalBuscarCliente gravam no Vuex InfoPedido) — sem isso o snapshot
    // pedidoentrega* não é enviado no payload da operação.
    unwatchEnderecoAlternativoStore: null,
    transporteId: null,
    // Aba ativa (0=Condições, 1=Itens, 2=Entrega) — usada para navegar
    // programaticamente até a aba Entrega quando transporte está faltando.
    tabAtiva: 0,
    // Marca o SelectTransporte como inválido visualmente após tentativa de salvar sem ele.
    collapseType: 'border',
    selected: null,
    required,
    show: false,
    representantesCount: 0,
    clientesCount: 0,
    isLoadingPromocoes: false,
    dadosCliente: {},
    aguardandoEnderecoObrigatorio: false,
    todayISO: new Date().toISOString().split('T')[0],
    ultimoPedidoResumo: null,
    isLoadingUltimoPedido: false,
    showImportarCsv: false,
    budgetCarrinho: null,
    budgetCheckTimer: null,
    budgetCheckSeq: 0,
    // Opção visual local da finalização; não integra pedido, rascunho ou store.
    boletoPara15Dias: false,
    pagamentoAVistaSelecionado: false,
    fields: ['mostrar_detalhes',
      { key: 'DescricaoMarca', label: 'Marca', sortable: true },
      { key: 'DescricaoReferencia', label: 'Referência', sortable: true },
      { key: 'sequencia', label: 'Sequência', sortable: true },
      { key: 'Qtde', label: 'Quantidade', sortable: true },
      // {key: 'PrecoUnitario', label: 'Valor Unitario', sortable: true},
      // {key: 'ValorTotal', label: 'Valor Total', sortable: true},
      { key: 'precoComImposto', label: 'Preço Unitario Final', sortable: true },
      { key: 'valorTotalComImposto', label: 'Valor Total Final', sortable: true },
      { key: 'promo', label: 'Tipo Pedido', sortable: true },
      // {key: 'editar', label: 'Editar', sortable: true},
      { key: 'excluir', label: 'Excluir', sortable: true },
    ],
    fieldsSub: [
      { key: 'itemId', label: 'Código', sortable: true },
      { key: 'item_descricao', label: 'Descrição', sortable: true },
      { key: 'marca', label: 'Marca', sortable: true },
      { key: 'des_cor', label: 'Cor', sortable: true },
      { key: 'embalagem', label: 'Embalagem', sortable: true },
      { key: 'pedidoItemQuantidade', label: 'QTD', sortable: true },
      // {key: 'precoUnitario', label: 'Valor Unitario', sortable: true},
      { key: 'precoComImposto', label: 'Valor Unitário Final', sortable: true },
      // {key: 'valorTotal', label: 'Valor Total', sortable: true},
      { key: 'valorTotalComImposto', label: 'Valor Total Final', sortable: true },
      { key: 'pedidoItemQuantidadeSaldo', label: 'QTD Saldo', sortable: true },
      { key: 'pedidoItemQuantidadeFaturada', label: 'QTD Faturado', sortable: true },
      { key: 'excluir', label: 'Excluir', sortable: false },
    ],
  }),
  watch: {
    isPedidoDoacaoAtual(isDoacao) {
      this.agendarChecagemBudget();
      if (isDoacao) {
        this.boletoPara15Dias = false;
        this.pagamentoAVistaSelecionado = false;
      }
      if (!isDoacao) this.restaurarEnderecoPadrao();
    },
    getListTabelaItens: {
      deep: true,
      handler() { this.agendarChecagemBudget(); },
    },
    'getFormData.dataCapaPedido.representanteid'() { this.agendarChecagemBudget(); },
    representanteBudgetId() { this.agendarChecagemBudget(); },
  },
  created() {
    // Campos privados não-reativos (Vue 2 não proxia props iniciadas com _)
    this._autoSaveDebounce = null;
    this._adocaoFetchedFor = null;
    // Endereço alternativo escolhido fora desta tela (home/ModalBuscarCliente
    // gravam no Vuex InfoPedido): sem esta semente o pedido da operação sai
    // SEM o snapshot pedidoentrega* e o detalhe mostra endereço vazio.
    this.unwatchEnderecoAlternativoStore = this.$store.watch(
      (state, getters) => getters['InfoPedido/GET_ENDERECO_ALTERNATIVO'],
      (novo) => {
        if (!this.isPedidoDoacaoAtual) {
          if (novo || this.enderecoAlternativo) this.restaurarEnderecoPadrao();
          return;
        }
        if (this.isPedidoDoacaoAtual && novo && novo.uf && novo.cidade) {
          this.enderecoAlternativo = { ...novo };
        } else if (!novo) {
          // Store limpo (troca de cliente) → não manter snapshot antigo local.
          this.enderecoAlternativo = null;
        }
      },
      { immediate: true },
    );
  },
  methods: {
    agendarChecagemBudget() {
      this.budgetCheckSeq += 1;
      this.budgetCarrinho = null;
      if (this.budgetCheckTimer) clearTimeout(this.budgetCheckTimer);
      this.budgetCheckTimer = null;
      const representanteid = this.representanteBudgetId;
      if (!this.isPedidoDoacaoAtual || !representanteid || !itensBudgetOperacao(this.getListTabelaItens).length) return;
      this.budgetCheckTimer = setTimeout(() => this.verificarBudgetCarrinho(), 600);
    },
    async verificarBudgetCarrinho() {
      this.budgetCheckTimer = null;
      const seq = ++this.budgetCheckSeq;
      this.budgetCarrinho = null;
      const representanteid = this.representanteBudgetId;
      const itens = itensBudgetOperacao(this.getListTabelaItens);
      if (!this.isPedidoDoacaoAtual || !representanteid || !itens.length) return;
      try {
        const { data: res } = await budgetClient.validarCarrinho({ representanteid, itens });
        if (seq === this.budgetCheckSeq) this.budgetCarrinho = res && res.data;
      } catch (e) {
        if (seq === this.budgetCheckSeq) this.budgetCarrinho = null;
      }
    },
    // ----- Endereço de entrega obrigatório (cliente sem endereço padrão) -----
    limparClienteSemEndereco() {
      this.$store.dispatch('intensPedido/resetDataCapaPedidoCliente');
      this.$store.commit('intensPedido/SET_CAPA_PEDIDO', {
        ...this.$store.getters['intensPedido/getFormData'].dataCapaPedido,
        clienteiderp: '',
        cliente_nome: '',
        tabelaprecoid: '',
        tabelapreco_descricao: '',
        condicaopagamentoid: '',
        condicaopagamentodescricao: '',
      });
      this.formInfoPedido.dataCapaPedido.clienteiderp = '';
      this.formInfoPedido.dataCapaPedido.cliente_nome = '';
      this.dadosCliente = null;
    },
    onEnderecoAlternativoInput(endereco) {
      if (endereco && endereco.uf && endereco.cidade) {
        if (!this.isPedidoDoacaoAtual) {
          this.restaurarEnderecoPadrao();
          return;
        }
        if (!this.enderecoEntregaPadrao) {
          this.enderecoEntregaPadrao = { ...(this.formInfoPedido.enderecoEntrega || {}) };
        }
        // Espelha no enderecoEntrega do form: é dele que as simulações de
        // imposto/preço leem UF e cidade.
        this.formInfoPedido.enderecoEntrega = {
          ...(this.formInfoPedido.enderecoEntrega || {}),
          clienteendereco: endereco.endereco || '',
          clienteendereconumero: endereco.numero || '',
          clienteenderecocomplemento: endereco.complemento || '',
          clienteenderecobairro: endereco.bairro || '',
          clienteenderecocidade: endereco.cidade || '',
          clienteenderecocep: endereco.cep || '',
          ufid: endereco.uf || '',
        };
        this.aguardandoEnderecoObrigatorio = false;
      }
    },
    restaurarEnderecoPadrao() {
      this.enderecoAlternativo = null;
      this.$store.commit('InfoPedido/SET_ENDERECO_ALTERNATIVO', null);
      if (this.enderecoEntregaPadrao) {
        this.formInfoPedido.enderecoEntrega = { ...this.enderecoEntregaPadrao };
        this.enderecoEntregaPadrao = null;
      }
    },
    onEnderecoAlternativoFechado() {
      // Modal fechado sem escolher endereço no fluxo obrigatório → cliente sem
      // endereço não pode ficar selecionado (imposto não calcula).
      if (!this.aguardandoEnderecoObrigatorio) return;
      this.aguardandoEnderecoObrigatorio = false;
      if (this.enderecoAlternativo) return;
      this.limparClienteSemEndereco();
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Endereço obrigatório',
          text: 'Este cliente não tem endereço cadastrado: para usá-lo é preciso informar o endereço de entrega. Selecione o cliente novamente para tentar de novo.',
          icon: 'AlertTriangleIcon',
          variant: 'warning',
        },
      });
    },
    abrirAutoCompletar() {
      if (this.$refs.modalAutoCompletar) {
        this.$refs.modalAutoCompletar.open();
      }
    },
    ...mapActions('intensPedido', [
      'removeItemListTabelaItens',
      'clearCreatePedido',
      'exibirItemEditar',
    ]),
    async confirmarSalvar() {
      // Pedido mínimo em modo AVISO (preferência BLOQUEAR_PEDIDO_MINIMO desativada):
      // permite finalizar abaixo do mínimo, mas destaca isso na confirmação.
      const abaixoDoMinimo = !this.pedidoMinimo && !this.bloqueioPedidoMinimoAtivo;
      const minimo = parseFloat(this.dadosCliente.valorMinimoPedido || 0);
      const result = await Swal.fire({
        title: abaixoDoMinimo ? 'Pedido abaixo do valor mínimo' : 'Confirmar Pedido',
        text: abaixoDoMinimo
          ? `O valor mínimo do pedido é R$ ${minimo.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}. Tem certeza que deseja finalizar mesmo assim?`
          : 'Tem certeza que deseja finalizar este pedido?',
        icon: abaixoDoMinimo ? 'warning' : 'question',
        showCancelButton: true,
        confirmButtonColor: '#28a745',
        cancelButtonColor: '#6c757d',
        confirmButtonText: 'Sim, finalizar pedido',
        cancelButtonText: 'Cancelar',
        reverseButtons: true,
      });

      if (result.isConfirmed) {
        await this.onSubmit();
      }
    },
    async confirmarRascunho() {
      const result = await Swal.fire({
        title: 'Salvar como Rascunho',
        text: 'O pedido será salvo como rascunho e poderá ser editado posteriormente.',
        icon: 'info',
        showCancelButton: true,
        confirmButtonColor: '#17a2b8',
        cancelButtonColor: '#6c757d',
        confirmButtonText: 'Sim, salvar rascunho',
        cancelButtonText: 'Cancelar',
        reverseButtons: true,
      });

      if (result.isConfirmed) {
        await this.onSubmitRascunho();
      }
    },
    resetBoletoPara15Dias() {
      this.boletoPara15Dias = false;
      this.pagamentoAVistaSelecionado = false;
      if (this.$refs.pagamentoAVistaVisual) this.$refs.pagamentoAVistaVisual.reset();
    },
    // getFormattedDateForInput(dateString) {
    //   if (!dateString) {
    //     return this.getDefaultDate();
    //   }

    //   if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
    //     return dateString;
    //   }

    //   if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateString)) {
    //     const parts = dateString.split('/');
    //     return `${parts[2]}-${parts[1]}-${parts[0]}`;
    //   }

    //   return dateString;
    // },
    // getDefaultDate() {
    //   const date = new Date();
    //   date.setDate(date.getDate() + 15);

    //   const year = date.getFullYear();
    //   const month = String(date.getMonth() + 1).padStart(2, '0');
    //   const day = String(date.getDate()).padStart(2, '0');

    //   return `${year}-${month}-${day}`;
    // },
    handleDateChange(event) {
      if (!event) return;

      const isoDate = event;
      const parts = isoDate.split('-');
      const formattedDate = `${parts[2]}/${parts[1]}/${parts[0]}`;

      this.$store.commit('intensPedido/SET_ENDERECO_ENTREGA', {
        ...this.formInfoPedido.enderecoEntrega,
        dataPrevistaEntrega: formattedDate,
      });

      const infoFormData = this.$store.getters['InfoPedido/GET_FORM_INFO_PEDIDO'];
      if (infoFormData && infoFormData.enderecoEntrega) {
        const merged = {
          ...infoFormData,
          enderecoEntrega: {
            ...infoFormData.enderecoEntrega,
            dataPrevistaEntrega: formattedDate,
          },
        };
        this.$store.commit('InfoPedido/SET_FORM_INFO_PEDIDO', merged);
      }

      console.log('Data atualizada para:', formattedDate);
    },
    calcularDataEntregaPadrao() {
      const hoje = new Date();
      const diasUteis = 5;

      const dataEntrega = new Date(hoje);
      let diasAdicionados = 0;

      while (diasAdicionados < diasUteis) {
        dataEntrega.setDate(dataEntrega.getDate() + 1);
        const diaDaSemana = dataEntrega.getDay();
        if (diaDaSemana !== 0 && diaDaSemana !== 6) {
          diasAdicionados++;
        }
      }

      return dataEntrega.toISOString().split('T')[0];
    },
    preventInvalidInput(event) {
      if (event.key === '0' && event.target.value === '') {
        event.preventDefault();
      }
      if (event.key === '-' || event.key === '+' || event.key === 'e' || event.key === 'E') {
        event.preventDefault();
      }
    },
    sanitizarMetadadosLinha(item) {
      const linha = { ...(item || {}) };
      delete linha._grp;
      delete linha._grpIndex;
      delete linha._subIndex;
      delete linha._marca;
      delete linha._referencia;
      delete linha._tipoPedido;
      return linha;
    },
    async handleQuantityDirectInput(row, subRow, event) {
      let newQuantity = parseInt(event) || 1;

      if (newQuantity < 1 || isNaN(newQuantity)) {
        newQuantity = 1;
      }

      const previousQuantity = Number(this.getListTabelaItens[row.index]?.itens?.[subRow.index]?.pedidoItemQuantidade) || 1;
      subRow.item.pedidoItemQuantidade = newQuantity;
      try {
        await this.handleQuantityChange(row, subRow);
      } catch (error) {
        subRow.item.pedidoItemQuantidade = previousQuantity;
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Preço da promoção não atualizado',
            text: error.message || 'A quantidade anterior foi mantida.',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        });
      }
    },
    validateQuantityOnBlur(row, subRow) {
      if (!subRow.item.pedidoItemQuantidade || subRow.item.pedidoItemQuantidade < 1) {
        subRow.item.pedidoItemQuantidade = 1;
        this.handleQuantityDirectInput(row, subRow, 1);
      }
    },
    async incrementQuantity(row, subRow) {
      console.log('Incrementando quantidade para:', { rowIndex: row.index, subRowIndex: subRow.index });

      if (!this.isValidIncrement(subRow)) return;
      subRow.item.pedidoItemQuantidade += 1;

      try {
        await this.handleQuantityChange(row, subRow);
      } catch (error) {
        subRow.item.pedidoItemQuantidade -= 1;
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Preço da promoção não atualizado',
            text: error.message || 'A quantidade anterior foi mantida.',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        });
      }
    },
    async decrementQuantity(row, subRow) {
      console.log('Decrementando quantidade para:', { rowIndex: row.index, subRowIndex: subRow.index });

      if (this.isValidDecrement(subRow)) {
        subRow.item.pedidoItemQuantidade -= 1;
        try {
          await this.handleQuantityChange(row, subRow);
        } catch (error) {
          subRow.item.pedidoItemQuantidade += 1;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Preço da promoção não atualizado',
              text: error.message || 'A quantidade anterior foi mantida.',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          });
        }
      }
    },
    isValidIncrement(subRow) {
      const item = subRow && subRow.item;
      if (!item || item.regra_pic === 'QE') return false;
      if (item.regra_pic === 'CS' && Number.isFinite(Number(item.saldo))
        && Number(item.saldo) > 0 && Number(item.pedidoItemQuantidade) >= Number(item.saldo)) {
        return false;
      }
      return true;
    },
    isValidDecrement(subRow) {
      return subRow.item.pedidoItemQuantidade > 1;
    },
    getMultiploTooltip() {
      return '';
    },
    async handleQuantityChange(row, subRow) {
      if (!row || row.index === undefined || !subRow || subRow.index === undefined) {
        console.error('Índices inválidos:', { row, subRow });
        return;
      }

      const itemAtual = this.getListTabelaItens[row.index];
      const subItemAtual = itemAtual && itemAtual.itens && itemAtual.itens[subRow.index];
      const quantidadeAnterior = Number(subItemAtual && subItemAtual.pedidoItemQuantidade);
      let newQuantity = parseInt(subRow.item.pedidoItemQuantidade);
      if (!Number.isFinite(quantidadeAnterior) || quantidadeAnterior < 1) {
        throw new Error('Quantidade anterior do item inválida.');
      }
      if (subRow.item.regra_pic === 'QE') {
        newQuantity = quantidadeAnterior;
      }
      if (subRow.item.regra_pic === 'CS' && Number.isFinite(Number(subRow.item.saldo))
        && Number(subRow.item.saldo) > 0) {
        newQuantity = Math.min(newQuantity, Number(subRow.item.saldo));
      }
      if (!Number.isFinite(newQuantity) || newQuantity < 1) newQuantity = quantidadeAnterior;
      const item = { ...row.item };
      const subItem = this.sanitizarMetadadosLinha(subRow.item);

      if (!item || !subItem) {
        console.error('Item ou subItem não encontrado:', { row, subRow });
        return;
      }

      // Promoções com faixa dependem da quantidade total do mesmo produto na
      // mesma PIC. A atualização é transacional: só substitui o grupo após
      // todas as simulações fiscais concluírem com sucesso.
      if (subItem.item_pic_promocao || subItem.picid || subItem.pic_id) {
        const gruposAtualizados = JSON.parse(JSON.stringify(this.getListTabelaItens || []));
        const grupoAlvo = gruposAtualizados[row.index];
        if (!grupoAlvo || !grupoAlvo.itens || !grupoAlvo.itens[subRow.index]) {
          throw new Error('Item da promoção não encontrado.');
        }
        grupoAlvo.itens[subRow.index].pedidoItemQuantidade = newQuantity;

        const mesmoProdutoPic = (a, b) => String(a.picid ?? a.pic_id ?? '') === String(b.picid ?? b.pic_id ?? '')
          && String(a.itemId ?? a.item_id ?? '') === String(b.itemId ?? b.item_id ?? '');
        const itensPic = [];
        gruposAtualizados.forEach((grupo, grupoIndex) => {
          (grupo.itens || []).forEach((linha, subIndex) => {
            if ((linha.item_pic_promocao || linha.picid || linha.pic_id)
              && mesmoProdutoPic(linha, grupoAlvo.itens[subRow.index])) {
              itensPic.push({
                ...linha,
                picitemquantidade: Number(linha.pedidoItemQuantidade),
                picitemprecobase: linha.picitemprecobase
                  ?? linha.picitemvalorpic
                  ?? linha.pedido_item_preco_unitario_base
                  ?? linha.precoUnitario,
                picitemfaixas: linha.picitemfaixas ?? [],
                picitemchave: `operacao:${grupoIndex}:${subIndex}`,
              });
            }
          });
        });
        if (!itensPic.length) throw new Error('Itens da promoção não encontrados.');

        const quantidadeTotal = itensPic.reduce((total, linha) => total + linha.picitemquantidade, 0);
        itensPic.forEach((linha) => { linha.picitemquantidadetotal = quantidadeTotal; });
        const capa = this.formInfoPedido.dataCapaPedido || {};
        const cliente = {
          ...(this.dadosCliente || {}),
          estabelecimento: (this.dadosCliente && this.dadosCliente.estabelecimento)
            || { estabelecimentoid: capa.estabelecimentoid, ufid: capa.ufestabelecimento },
          cliente: (this.dadosCliente && this.dadosCliente.cliente)
            || { clientenomeabreviado: capa.clientenomeabreviado, clientenatoperinterna: capa.clientenatoperinterna, clientenatoperexterna: capa.clientenatoperexterna },
          naturezaOperacao: (this.dadosCliente && this.dadosCliente.naturezaOperacao)
            || { naturezaoperacaoid: capa.naturezaoperacaoid },
          canalVenda: (this.dadosCliente && this.dadosCliente.canalVenda)
            || { canal_venda_id: capa.canalvendaid || capa.canal_venda_id },
        };
        const endereco = this.enderecoAlternativo
          ? { ufid: this.enderecoAlternativo.uf, clienteenderecocidade: this.enderecoAlternativo.cidade }
          : (this.formInfoPedido.enderecoEntrega || {});
        const impostos = await calcularImpostosPic(itensPic, cliente, capa, endereco);
        itensPic.forEach((linha) => {
          const imposto = impostos.find((resultado) => resultado.picitemchave === linha.picitemchave);
          if (!imposto || !Number(imposto.precoUnitario) || !Number(imposto.precoComImposto)) {
            throw new Error(`Não foi possível recalcular os impostos do item ${linha.itemId || linha.item_id}.`);
          }
          const [grupoIndex, subIndex] = linha.picitemchave.split(':').slice(1).map(Number);
          const destino = gruposAtualizados[grupoIndex].itens[subIndex];
          destino.pedidoItemQuantidade = linha.picitemquantidade;
          destino.precoUnitario = Number(imposto.precoUnitario);
          destino.picitemvalorpic = Number(imposto.precoUnitario);
          destino.picitemquantidadetotal = quantidadeTotal;
          destino.picitemdesconto = imposto.desconto;
          destino.picitemfaixa = imposto.faixa;
          destino.precoComImposto = Number(imposto.precoComImposto);
          destino.precoTabelaErp = imposto.precoTabelaErp;
          destino.valorTotal = +(destino.precoUnitario * destino.pedidoItemQuantidade).toFixed(2);
          destino.valorTotalComImposto = +(destino.precoComImposto * destino.pedidoItemQuantidade).toFixed(2);
          destino.baseIcms = imposto.baseIcms || 0;
          destino.valorIcms = imposto.valorIcms || 0;
          destino.naturezaoperacaoidimposto = imposto.naturezaoperacaoidimposto || 0;
          destino.base_icms = imposto.baseIcms || 0;
          destino.valor_icms = imposto.valorIcms || 0;
          destino.natureza_operacao_id_imposto = imposto.naturezaoperacaoidimposto || 0;
        });
        gruposAtualizados.forEach((grupo) => {
          grupo.Qtde = (grupo.itens || []).reduce((total, linha) => total + Number(linha.pedidoItemQuantidade || 0), 0);
          grupo.ValorTotal = (grupo.itens || []).reduce((total, linha) => total + Number(linha.valorTotal || 0), 0);
          grupo.ValorTotalComImposto = (grupo.itens || []).reduce(
            (total, linha) => total + Number(linha.valorTotalComImposto || 0), 0,
          );
        });
        this.$store.commit('intensPedido/SET_TABELA_ITENS_PIC', gruposAtualizados);
        subRow.item.pedidoItemQuantidade = newQuantity;
        return;
      }

      console.log('Valores antes da atualização:', {
        quantidade: subItem.pedidoItemQuantidade,
        precoUnitario: subItem.precoUnitario,
        precoComImposto: subItem.precoComImposto,
        valorTotalAtual: subItem.valorTotal,
        valorTotalComImpostoAtual: subItem.valorTotalComImposto,
      });

      const precoComImposto = parseFloat(subItem.precoComImposto || subItem.precoUnitario);

      subItem.valorTotal = parseFloat(subItem.precoUnitario) * newQuantity;
      subItem.valorTotalComImposto = precoComImposto * newQuantity;

      console.log('Novos valores calculados para o subitem:', {
        quantidade: newQuantity,
        valorTotal: subItem.valorTotal,
        valorTotalComImposto: subItem.valorTotalComImposto,
      });

      const updatedItens = (item.itens || []).map((itemAtual, index) => (
        index === subRow.index
          ? subItem
          : this.sanitizarMetadadosLinha(itemAtual)
      ));

      const valorTotalComImpostos = updatedItens.reduce(
        (sum, si) => sum + parseFloat(si.valorTotalComImposto || si.valorTotal || 0), 0,
      );

      const updatedItem = {
        ...item,
        itens: updatedItens,
        Qtde: updatedItens.reduce((sum, si) => sum + parseInt(si.pedidoItemQuantidade || 0), 0),
        ValorTotal: updatedItens.reduce((sum, si) => sum + parseFloat(si.valorTotal || 0), 0),
        ValorTotalComImposto: valorTotalComImpostos,
      };

      console.log('Item atualizado:', {
        Qtde: updatedItem.Qtde,
        ValorTotal: updatedItem.ValorTotal,
        ValorTotalComImposto: updatedItem.ValorTotalComImposto,
        itensLength: updatedItem.itens.length,
      });

      try {
        this.$store.commit('intensPedido/UPDATE_TABELA_ITEM', {
          index: row.index,
          item: updatedItem,
        });

        const totalAtual = this.$store.getters['intensPedido/getTotalPedido'];
        const valorMinimo = parseFloat(this.dadosCliente.valorMinimoPedido || 0);

        // console.log('Total com impostos recalculado após atualização:', {
        //   totalAtual,
        //   valorMinimo,
        //   pedidoMinimo: totalAtual >= valorMinimo,
        // });
      } catch (error) {
        console.error('Erro ao atualizar quantidade:', error);
        // Nunca altere novamente a quantidade no rollback: isso fazia o botão
        // "-" subtrair duas unidades e o valor digitado aparecer como N-1.
        subRow.item.pedidoItemQuantidade = newQuantity;
      }
    },
    removeLeadingZeros(value) {
      if (!value) return '';
      return String(value).replace(/^0+/, '');
    },
    // limparFormulario() {
    //   this.$bvModal.msgBoxConfirm('Tem certeza que deseja limpar todos os campos do formulário?', {
    //     title: 'Confirmar limpeza',
    //     size: 'sm',
    //     buttonSize: 'sm',
    //     okVariant: 'danger',
    //     okTitle: 'Sim, limpar',
    //     cancelTitle: 'Cancelar',
    //     footerClass: 'p-2',
    //     hideHeaderClose: false,
    //     centered: true
    //   })
    //     .then(value => {
    //       if (value) {
    //         const representanteData = this.$store.getters["InfoPedido/GET_FORM_INFO_PEDIDO"].representante;
    //         this.clearCreatePedido();
    //         this.$store.commit('PicStore/RESET_PIC_SELECTION');

    //         if (representanteData && representanteData.representanteid) {
    //           this.$store.commit('InfoPedido/SET_REPRESENTANTE_FORM', representanteData);
    //           this.$store.commit('SLSRepresentante/SET_SELECTED_REPRESENTANTE', representanteData);
    //           this.$store.commit('InfoPedido/SET_REPRESENTANTE_READONLY', true);
    //           this.$store.commit('intensPedido/SET_IFO_REPRESENTANTE', {
    //             representanteid: representanteData.representanteid,
    //             representantenome: representanteData.representantenome,
    //           });
    //         }

    //         if (this.$store.getters['auth/IS_LOGGED_IN']) {
    //           const userId = this.getUserId();
    //           if (representanteData && representanteData.representanteid) {
    //             const formData = {
    //               ...this.$store.getters["InfoPedido/GET_FORM_INFO_PEDIDO"],
    //               representante: representanteData
    //             };
    //             localStorage.setItem(`infoPedidoForm_${userId}`, JSON.stringify(formData));
    //           } else {
    //             localStorage.removeItem(`infoPedidoForm_${userId}`);
    //           }
    //         }

    //         this.$toast({
    //           component: ToastificationContent,
    //           props: {
    //             title: 'Formulário limpo',
    //             text: 'Todos os campos foram limpos com sucesso.',
    //             icon: 'CheckIcon',
    //             variant: 'success',
    //           },
    //         });
    //       }
    //     })
    //     .catch(err => {
    //       console.error(err);
    //     });
    // },
    getUserId() {
      try {
        const userData = JSON.parse(localStorage.getItem('userData'));
        return userData?.id || userData?.userData?.id || 'default';
      } catch (error) {
        console.error('Erro ao obter ID do usuário:', error);
        return 'default';
      }
    },
    handleCondPagtoKeydown(event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        this.onChangeCondPagto(event);
      }
    },
    verificarPerfilUsuario() {
      try {
        const perfilLogado = JSON.parse(localStorage.getItem('perfilLogado'));
        const isClienteFinal = perfilLogado && ['Cliente', 'ClienteFinal', 'Representante', 'Supervisor']
          .includes(perfilLogado.perfil_acesso_nome);
        if (isClienteFinal) {
          this.contarRepresentantesEClientes();
        }
      } catch (error) {
        console.error('Erro ao verificar perfil do usuário:', error);
      }
    },
    async contarRepresentantesEClientes() {
      try {
        await this.$store.dispatch('SLSRepresentante/resertFilters');
        const representantes = await slsRepresentanteService.listarRepresentanteInfoPedido();
        this.representantesCount = representantes ? representantes.length : 0;

        if (this.representantesCount === 1 && representantes[0]) {
          this.formInfoPedido.dataCapaPedido.representanteid = representantes[0].representanteid;
          this.formInfoPedido.dataCapaPedido.representantenome = representantes[0].representantenome;
          this.$store.commit('SLSRepresentante/SET_SELECTED_REPRESENTANTE', representantes[0]);

          const representanteId = representantes[0].representanteid;

          await this.$store.commit('SLSCliente/SET_FILTERS', {
            page: 1,
            perPage: 100,
            representanteid: representanteId,
          });

          const clientes = await slsClienteService.listarClienteInfoPedido({ representanteid: representanteId });
          this.clientesCount = clientes ? clientes.length : 0;

          if (this.clientesCount === 1 && clientes[0]) {
            await this.onChagenClienteAuto(clientes[0]);
          }
        }
      } catch (error) {
        console.error('Erro ao contar representantes e clientes:', error);
      }
    },
    async onChagenClienteAuto(cliente) {
      if (!cliente) return;

      this.formInfoPedido.dataCapaPedido.clienteiderp = cliente.clienteiderp;
      await this.onChagenCliente();
    },
    async onChangeCondPagto(event) {
      this.$store.commit('PicStore/RESET_PIC_SELECTION');

      const codigoCondPagto = typeof event === 'object' && event.target
        ? event.target.value
        : this.formInfoPedido.dataCapaPedido.condicaopagamentoid;

      if (!codigoCondPagto || !codigoCondPagto.length) {
        this.formInfoPedido.dataCapaPedido.condicaopagamentodescricao = '';
        return;
      }

      this.$store.commit('intensPedido/SET_IS_LOADING', true);

      try {
        const clienteId = this.formInfoPedido.dataCapaPedido.clienteid
          || this.formInfoPedido.enderecoEntrega?.clienteid;

        if (!clienteId) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Cliente não selecionado',
              text: 'Selecione um cliente antes de definir a condição de pagamento.',
              icon: 'AlertTriangleIcon',
              variant: 'warning',
            },
          });
          this.formInfoPedido.dataCapaPedido.condicaopagamentoid = '';
          this.formInfoPedido.dataCapaPedido.condicaopagamentodescricao = '';
          return;
        }

        const condPagamentos = await slsCondicaoPagamentoService.GetCondPagtoByClienteId(clienteId);

        if (!Array.isArray(condPagamentos) || condPagamentos.length === 0) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Sem condições de pagamento',
              text: 'Não foram encontradas condições de pagamento para este cliente.',
              icon: 'AlertTriangleIcon',
              variant: 'warning',
            },
          });
          this.formInfoPedido.dataCapaPedido.condicaopagamentoid = '';
          this.formInfoPedido.dataCapaPedido.condicaopagamentodescricao = '';
          return;
        }

        const existCondPagto = condPagamentos.find(
          (cond) => String(cond.condicaopagamentoid) === String(codigoCondPagto),
        );

        if (existCondPagto) {
          this.formInfoPedido.dataCapaPedido.condicaopagamentodescricao = existCondPagto.condicaopagamentodescricao;
          this.$store.commit('PicStore/SET_FILTERS_CONDICAOPAGAMENTO_ID', existCondPagto.condicaopagamentoid);
          await picService.getPicPedidos();
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Condição não encontrada',
              text: 'Não foi encontrada condição de pagamento com este código para o cliente.',
              icon: 'AlertTriangleIcon',
              variant: 'warning',
            },
          });
          this.formInfoPedido.dataCapaPedido.condicaopagamentoid = '';
          this.formInfoPedido.dataCapaPedido.condicaopagamentodescricao = '';
        }
      } catch (error) {
        console.error('Erro ao buscar condição de pagamento:', error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erro',
            text: 'Erro ao buscar condição de pagamento. Tente novamente.',
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        });
        this.formInfoPedido.dataCapaPedido.condicaopagamentoid = '';
        this.formInfoPedido.dataCapaPedido.condicaopagamentodescricao = '';
      } finally {
        this.$store.commit('intensPedido/SET_IS_LOADING', false);
      }
    },
    async openModal() {
      const info = this.$store.getters['InfoPedido/GET_FORM_INFO_PEDIDO'];
      this.$store.commit('intensPedido/SET_FORM_DATA', {
        dataCapaPedido: {
          tabelaprecoid: info?.tabelaPreco?.tabelapreco_id,
          clienteiderp: info?.cliente?.clienteiderp,
          estabelecimentoid: info?.estabelecimento?.estabelecimentoid,
          representanteid: this.representanteBudgetId,
        },
      });
      await this.$refs['adicionar-itens-pedido'].show('novo', null);
    },
    async openModalPic() {
      if (!this.picAtivo || !this.podeBuscarPromocoes) return;
      const capa = this.formInfoPedido.dataCapaPedido;
      this.$store.commit('PicStore/SET_FILTERS', {
        estabelecimentoid: capa.estabelecimentoid,
        clienteid: capa.clienteid,
        tabelaprecoId: capa.tabelaprecoid,
        condicaopagamentoid: capa.condicaopagamentoid,
      });
      const operacaoData = {
        estabelecimento: {
          estabelecimentoid: this.formInfoPedido.dataCapaPedido.estabelecimentoid,
          ufid: this.dadosCliente?.estabelecimento?.ufid || this.formInfoPedido.dataCapaPedido.ufestabelecimento,
        },
        cliente: {
          clienteid: this.dadosCliente?.cliente?.clienteid,
          clientenomeabreviado: this.formInfoPedido.dataCapaPedido.clientenomeabreviado,
          clientenatoperinterna: this.dadosCliente?.cliente?.clientenatoperinterna || this.formInfoPedido.dataCapaPedido.clientenatoperinterna,
          clientenatoperexterna: this.dadosCliente?.cliente?.clientenatoperexterna || this.formInfoPedido.dataCapaPedido.clientenatoperexterna,
        },
        naturezaOperacao: {
          naturezaoperacaoid: this.formInfoPedido.dataCapaPedido.naturezaoperacaoid,
        },
        canalVenda: {
          canal_venda_id: this.formInfoPedido.dataCapaPedido.canalvendaid,
        },
        enderecoEntrega: {
          ufid: this.formInfoPedido.enderecoEntrega.ufid,
          clienteenderecocidade: this.formInfoPedido.enderecoEntrega.clienteenderecocidade,
        },
        clienteisentoie: this.formInfoPedido.dataCapaPedido.clienteisentoie,
        tabelaprecoid: this.formInfoPedido.dataCapaPedido.tabelaprecoid,
        condicaopagamentoid: this.formInfoPedido.dataCapaPedido.condicaopagamentoid,
      };

      this.$root.$emit('openModal:pic', {
        type: 'operacao-pedido',
        operacao: 'create',
        data: operacaoData,
      });
    },
    async loadingRepresentantes() {
      // const representantes = this.$store.getters['SLSRepresentante/representantes'];
      // if (representantes && representantes.length > 0) {
      //   console.log('Representantes já carregados, usando cache');
      //   return;
      // }

      await this.$store.dispatch('SLSRepresentante/resertFilters');
      this.$store.commit('SLSRepresentante/SET_FILTERS_PER_PAGE', 10);
      await slsRepresentanteService.listarRepresentanteInfoPedido();
    },
    async onChageCodigoRepresentante() {
      this.$store.commit('intensPedido/SET_IS_LOADING_CAPA_PEDIDO', true);

      await this.$store.dispatch('intensPedido/resetDataCapaPedidoCliente');

      this.$store.commit('intensPedido/SET_CAPA_PEDIDO', {
        ...this.formInfoPedido.dataCapaPedido,
        clienteiderp: '',
        cliente_nome: '',
        clientenomeabreviado: '',
        clienteisentoie: '',
        condicaopagamentoid: '',
        condicaopagamentodescricao: '',
        tabelaprecoid: '',
        tabelapreco_descricao: '',
        naturezaoperacaoid: '',
        naturezaoperacaodescricao: '',
        canalvendaid: '',
        canal_venda_descricao: '',
        estabelecimentoid: '',
        estabelecimentorazaosocial: '',
      });

      this.$store.commit('InfoPedido/SET_OPTIONS_TABELA_PRECO', []);
      this.$store.commit('InfoPedido/SET_OPTIONS_COND_PAGAMENTO', []);
      this.$store.commit('SLSCondicaoPagamento/SET_CURRENT_COND_PAGTO', []);

      this.$store.commit('PicStore/RESET_PIC_SELECTION');

      if (!this.formInfoPedido.dataCapaPedido.representanteid) {
        await this.$store.dispatch('intensPedido/resetDataCapaPedido');
        this.$store.commit('intensPedido/SET_IS_LOADING_CAPA_PEDIDO', false);
        return;
      }

      try {
        await this.$store.dispatch('SLSRepresentante/resertFilters');
        this.$store.commit('SLSRepresentante/SET_FILTERS_REPRESENTANTE_ID', this.formInfoPedido.dataCapaPedido.representanteid);
        this.$store.commit('SLSRepresentante/SET_FILTERS_PER_PAGE', 10);

        const response = await slsRepresentanteService.listarRepresentanteInfoPedido();

        if (response && response.success === false) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: response.title || 'Representante não autorizado',
              text: response.message || 'Você não tem permissão para acessar este representante.',
              icon: 'AlertTriangleIcon',
              variant: 'warning',
            },
          });

          this.formInfoPedido.dataCapaPedido.representanteid = '';
          this.formInfoPedido.dataCapaPedido.representantenome = '';
          this.$store.commit('intensPedido/SET_IS_LOADING_CAPA_PEDIDO', false);
          return;
        }

        if (response && response.length > 0) {
          const representante = response[0];

          this.formInfoPedido.dataCapaPedido.representantenome = representante.representantenome;
          this.$store.commit('SLSRepresentante/SET_SELECTED_REPRESENTANTE', representante);

          await slsClienteService.listarClienteInfoPedido({
            representanteid: this.formInfoPedido.dataCapaPedido.representanteid,
          });
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Representante não encontrado',
              text: 'O representante informado não foi encontrado, por favor, verifique o código!',
              icon: 'AlertTriangleIcon',
              variant: 'warning',
            },
          });
          this.formInfoPedido.dataCapaPedido.representantenome = '';
        }
      } catch (error) {
        console.error('Erro ao buscar representante:', error);

        if (error.response && error.response.data) {
          const errorData = error.response.data;

          this.$toast({
            component: ToastificationContent,
            props: {
              title: errorData.title || 'Erro ao buscar representante',
              text: errorData.message || 'Não foi possível buscar os dados do representante. Tente novamente.',
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          });
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Erro ao buscar representante',
              text: 'Não foi possível buscar os dados do representante. Tente novamente.',
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          });
        }

        this.formInfoPedido.dataCapaPedido.representantenome = '';
      } finally {
        this.$store.commit('intensPedido/SET_IS_LOADING_CAPA_PEDIDO', false);
      }
    },
    async loadingClientes() {
      const representanteId = this.formInfoPedido.dataCapaPedido.representanteid;
      // const clientes = this.$store.getters['SLSCliente/clientes'];
      // const storedFilters = this.$store.getters['SLSCliente/filters'];

      // if (clientes && clientes.length > 0 && storedFilters.representanteid === representanteId) {
      //   console.log('Clientes já carregados para este representante, usando cache');
      //   return;
      // }

      await slsClienteService.listarClienteInfoPedido({
        representanteid: representanteId,
        perPage: 10,
      });
    },
    async onChagenCliente() {
      this.$store.commit('intensPedido/SET_IS_LOADING_IFO_CLIENTE', true);
      this.$store.commit('intensPedido/SET_IS_LOADING', true);
      this.$store.commit('PicStore/RESET_PIC_SELECTION');

      if (!this.formInfoPedido.dataCapaPedido.clienteiderp) {
        await this.$store.dispatch('intensPedido/resetDataCapaPedidoCliente');
        this.$store.commit('intensPedido/SET_IS_LOADING_IFO_CLIENTE', false);
        this.$store.commit('intensPedido/SET_IS_LOADING', false);
        return;
      }

      try {
        const representanteId = this.formInfoPedido.dataCapaPedido.representanteid;
        const clienteIdDigitado = this.formInfoPedido.dataCapaPedido.clienteiderp;
        const clienteIdDigitadoSemZeros = this.removeLeadingZeros(clienteIdDigitado);

        const clientesDoRepresentante = await slsClienteService.listarClienteInfoPedido({
          representanteid: representanteId,
          perPage: 10,
        });

        const clienteEncontrado = clientesDoRepresentante.find(
          (cliente) => this.removeLeadingZeros(cliente.clienteiderp) === clienteIdDigitadoSemZeros,
        );

        if (!clienteEncontrado) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Cliente não encontrado',
              text: 'Tente novamente.',
              icon: 'AlertTriangleIcon',
              variant: 'warning',
            },
          });

          await this.$store.dispatch('intensPedido/resetDataCapaPedidoCliente');
          this.formInfoPedido.dataCapaPedido.clienteiderp = '';
          this.formInfoPedido.dataCapaPedido.cliente_nome = '';

          this.$store.commit('intensPedido/SET_IS_LOADING_IFO_CLIENTE', false);
          this.$store.commit('intensPedido/SET_IS_LOADING', false);
          return;
        }

        const data = await slsClienteService.getInfoPedidoNovo(clienteEncontrado.clienteiderp);
        console.log('Dados do cliente recebidos:', data);

        if (!data) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Cliente não encontrado',
              text: 'O cliente informado não foi encontrado, por favor, verifique o código informado!',
              icon: 'AlertTriangleIcon',
              variant: 'warning',
            },
          });
          return;
        }

        const representanteIdSelecionado = this.formInfoPedido.dataCapaPedido.representanteid;
        const representanteIdCliente = data.representante?.representanteid;

        if (representanteIdSelecionado
          && representanteIdCliente
          && representanteIdCliente !== representanteIdSelecionado) {
          await this.$store.dispatch('intensPedido/resetDataCapaPedidoCliente');

          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Cliente não encontrado',
              text: 'Tente novamente.',
              icon: 'AlertTriangleIcon',
              variant: 'warning',
            },
          });

          this.formInfoPedido.dataCapaPedido.clienteiderp = '';
          this.formInfoPedido.dataCapaPedido.cliente_nome = '';
          return;
        }

        this.dadosCliente = data;
        this.$store.commit('intensPedido/SET_IFO_CLIENTE', data);

        if (data.enderecoEntrega) {
          this.$store.commit('intensPedido/SET_ENDERECO_ENTREGA', {
            clienteendereco: data.enderecoEntrega.clienteendereco || '',
            clienteendereconumero: data.enderecoEntrega.clienteendereconumero || '',
            clienteenderecocomplemento: data.enderecoEntrega.clienteenderecocomplemento || '',
            clienteenderecobairro: data.enderecoEntrega.clienteenderecobairro || '',
            clienteenderecocidade: data.enderecoEntrega.clienteenderecocidade || '',
            clienteenderecocep: data.enderecoEntrega.clienteenderecocep || '',
            ufid: data.enderecoEntrega.ufid || '',
            clienteid: data.cliente?.clienteid || '',
            tipoenderecoid: data.enderecoEntrega.tipoenderecoid || '',
            dataPrevistaEntrega: data.enderecoEntrega.dataPrevistaEntrega || this.calcularDataEntregaPadrao(),
          });
        } else if (data.cliente) {
          this.$store.commit('intensPedido/SET_ENDERECO_ENTREGA', {
            clienteendereco: data.cliente.clienteendereco || '',
            clienteendereconumero: data.cliente.clienteendereconumero || '',
            clienteenderecocomplemento: data.cliente.clienteenderecocomplemento || '',
            clienteenderecobairro: data.cliente.clienteenderecobairro || '',
            clienteenderecocidade: data.cliente.clienteenderecocidade || '',
            clienteenderecocep: data.cliente.clienteenderecocep || '',
            ufid: data.cliente.ufid || '',
            clienteid: data.cliente.clienteid || '',
            // FK sls_TipoEndereco usa ids string ('PADRAO'); sem endereço real → null
            tipoenderecoid: null,
            dataPrevistaEntrega: this.calcularDataEntregaPadrao(),
          });
        }

        // Sem endereço com UF + cidade a TOTVS devolve imposto/preço zerados.
        // Cliente sem endereço → o usuário é OBRIGADO a informar o endereço de
        // entrega agora (ou trocar de cliente).
        const decisaoEndereco = await exigirEnderecoEntrega(data);
        if (decisaoEndereco === 'trocar') {
          this.limparClienteSemEndereco();
          return;
        }
        if (decisaoEndereco === 'escolher') {
          this.aguardandoEnderecoObrigatorio = true;
          this.$nextTick(() => {
            if (this.$refs.escolherEnderecoEntrega) this.$refs.escolherEnderecoEntrega.abrir();
          });
        }

        // Merge não destrutivo do formInfoPedido existente
        const currentForm = this.$store.getters['InfoPedido/GET_FORM_INFO_PEDIDO'] || {};
        const mergedForm = {
          ...currentForm,
          cliente: {
            ...(currentForm.cliente || {}),
            clienteid: data.cliente.clienteid,
            clienteiderp: data.cliente.clienteiderp,
            clienterazaosocial: data.cliente.clienterazaosocial,
          },
          representante: {
            ...(currentForm.representante || {}),
            representanteid: this.formInfoPedido.dataCapaPedido.representanteid,
            representantenome: this.formInfoPedido.dataCapaPedido.representantenome,
          },
        };
        this.$store.commit('InfoPedido/SET_FORM_INFO_PEDIDO', mergedForm);

        if (Array.isArray(data.optionsCondPagtoCliente) && data.optionsCondPagtoCliente.length === 1) {
          this.$store.commit('InfoPedido/SET_OPTIONS_COND_PAGAMENTO', data.optionsCondPagtoCliente);
          this.$store.commit('SLSCondicaoPagamento/SET_CURRENT_COND_PAGTO', data.optionsCondPagtoCliente);
        }

        if (Array.isArray(data.optionsTabelaPrecoCliente) && data.optionsTabelaPrecoCliente.length === 1) {
          const unicaTabelaPreco = data.optionsTabelaPrecoCliente[0];

          this.formInfoPedido.dataCapaPedido.tabelaprecoid = unicaTabelaPreco.tabelapreco_id;
          this.formInfoPedido.dataCapaPedido.tabelapreco_descricao = unicaTabelaPreco.tabelapreco_descricao;
        }

        if (data.cliente?.clienteid) {
          try {
            const condPagamentos = await slsCondicaoPagamentoService.GetCondPagtoByClienteId(data.cliente.clienteid);
            // Vínculos vazios NÃO limpam a condição quando o backend já trouxe
            // um padrão (fallback p/ clientes do ERP sem vínculo).
            if ((!Array.isArray(condPagamentos) || condPagamentos.length === 0)
              && !this.formInfoPedido.dataCapaPedido.condicaopagamentoid) {
              console.log('Cliente não possui condições de pagamento');
              this.formInfoPedido.dataCapaPedido.condicaopagamentoid = '';
              this.formInfoPedido.dataCapaPedido.condicaopagamentodescricao = '';

              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Aviso',
                  text: 'Não foram encontradas condições de pagamento para este cliente',
                  icon: 'AlertTriangleIcon',
                  variant: 'warning',
                },
              });
            }
          } catch (error) {
            console.warn('Erro ao buscar condições de pagamento:', error);
            this.formInfoPedido.dataCapaPedido.condicaopagamentoid = '';
            this.formInfoPedido.dataCapaPedido.condicaopagamentodescricao = '';
          }
        }

        if (data.cliente?.clienteiderp) {
          try {
            const tabelasPreco = await slsTabelapreco.getTabelaPrecoByClienteIdERP(data.cliente.clienteiderp);
            if ((!Array.isArray(tabelasPreco) || tabelasPreco.length === 0)
              && !this.formInfoPedido.dataCapaPedido.tabelaprecoid) {
              console.log('Cliente não possui tabelas de preço');
              this.formInfoPedido.dataCapaPedido.tabelaprecoid = '';
              this.formInfoPedido.dataCapaPedido.tabelapreco_descricao = '';

              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Aviso',
                  text: 'Não foram encontradas tabelas de preço para este cliente',
                  icon: 'AlertTriangleIcon',
                  variant: 'warning',
                },
              });
            }
          } catch (error) {
            console.warn('Erro ao buscar tabela de preço:', error);
            this.formInfoPedido.dataCapaPedido.tabelaprecoid = '';
            this.formInfoPedido.dataCapaPedido.tabelapreco_descricao = '';
          }
        }

        const filtrosPic = {};

        if (data.cliente?.clienteid) filtrosPic.clienteid = data.cliente.clienteid;
        if (data.estabelecimento?.estabelecimentoid) filtrosPic.estabelecimentoid = data.estabelecimento.estabelecimentoid;
        if (data.tabelaPreco?.tabelapreco_id) filtrosPic.tabelaprecoId = data.tabelaPreco.tabelapreco_id;
        if (data.condicaoPagamento?.condicaopagamentoid) filtrosPic.condicaopagamentoid = data.condicaoPagamento.condicaopagamentoid;

        if (Object.keys(filtrosPic).length > 0) {
          this.$store.commit('PicStore/SET_FILTERS', filtrosPic);
          await picService.getPicPedidos();
        }
      } catch (error) {
        console.error('Erro ao buscar cliente:', error);
        this.$store.commit('intensPedido/SET_IS_LOADING_IFO_CLIENTE', false);
        this.$store.commit('intensPedido/SET_IS_LOADING', false);

        // await Swal.fire({
        //   title: 'Erro ao buscar cliente',
        //   text: 'Não foi possível buscar os dados do cliente. Tente novamente.',
        //   icon: 'error',
        //   confirmButtonText: 'OK'
        // });
      } finally {
        this.$store.commit('intensPedido/SET_IS_LOADING_IFO_CLIENTE', false);
        this.$store.commit('intensPedido/SET_IS_LOADING', false);
      }
    },
    async onChageCodigoTabelaPreco(event) {
      const codTabelaPreco = typeof event === 'object' && event.target
        ? event.target.value
        : this.formInfoPedido.dataCapaPedido.tabelaprecoid;

      this.$store.commit('PicStore/SET_FILTERS_TABELAPRECO_ID', codTabelaPreco);

      if (!codTabelaPreco || !codTabelaPreco.length) {
        this.formInfoPedido.dataCapaPedido.tabelaprecoid = '';
        this.formInfoPedido.dataCapaPedido.tabelapreco_descricao = '';
        return;
      }

      this.$store.commit('InfoPedido/SET_LOADING_TABELA_PRECO', true);

      try {
        const clienteIdERP = this.formInfoPedido.dataCapaPedido.clienteiderp;
        if (!clienteIdERP) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Cliente não selecionado',
              text: 'Selecione um cliente antes de definir a tabela de preço.',
              icon: 'AlertTriangleIcon',
              variant: 'warning',
            },
          });
          this.formInfoPedido.dataCapaPedido.tabelaprecoid = '';
          this.formInfoPedido.dataCapaPedido.tabelapreco_descricao = '';
          return;
        }

        const response = await slsTabelapreco.getTabelaPrecoByClienteIdERP(clienteIdERP);

        if (!Array.isArray(response) || response.length === 0) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Sem tabelas de preço',
              text: 'Não foram encontradas tabelas de preço para este cliente.',
              icon: 'AlertTriangleIcon',
              variant: 'warning',
            },
          });
          this.formInfoPedido.dataCapaPedido.tabelaprecoid = '';
          this.formInfoPedido.dataCapaPedido.tabelapreco_descricao = '';
          return;
        }

        const currentTabelaPreco = this.$store.getters['SLSTabelapreco/tabelaprecos'].find(
          (tabelaPreco) => String(tabelaPreco.tabelapreco_id).toUpperCase() === String(codTabelaPreco).toUpperCase(),
        );

        if (!currentTabelaPreco) {
          this.formInfoPedido.dataCapaPedido.tabelaprecoid = '';
          this.formInfoPedido.dataCapaPedido.tabelapreco_descricao = '';

          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Tabela de preço não encontrada',
              text: 'A tabela de preço informada não foi encontrada, por favor, verifique o código informado!',
              icon: 'AlertTriangleIcon',
              variant: 'warning',
            },
          });
          return;
        }

        this.formInfoPedido.dataCapaPedido.tabelaprecoid = currentTabelaPreco.tabelapreco_id;
        this.formInfoPedido.dataCapaPedido.tabelapreco_descricao = currentTabelaPreco.tabelapreco_descricao;

        if (this.formInfoPedido.dataCapaPedido.clienteiderp) {
          const filtrosPic = {};

          if (this.dadosCliente.cliente?.clienteid) filtrosPic.clienteid = this.dadosCliente.cliente.clienteid;
          if (this.dadosCliente.estabelecimento?.estabelecimentoid) filtrosPic.estabelecimentoid = this.dadosCliente.estabelecimento.estabelecimentoid;
          if (currentTabelaPreco?.tabelapreco_id) filtrosPic.tabelaprecoId = currentTabelaPreco.tabelapreco_id;
          if (this.formInfoPedido.dataCapaPedido.condicaopagamentoid) filtrosPic.condicaopagamentoid = this.formInfoPedido.dataCapaPedido.condicaopagamentoid;

          if (Object.keys(filtrosPic).length > 0) {
            this.$store.commit('PicStore/SET_FILTERS', filtrosPic);
            await picService.getPicPedidos();
          }
        }
      } catch (error) {
        console.error('Erro ao buscar tabela de preço:', error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erro',
            text: 'Ocorreu um erro ao buscar a tabela de preço. Tente novamente.',
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        });
        this.formInfoPedido.dataCapaPedido.tabelaprecoid = '';
        this.formInfoPedido.dataCapaPedido.tabelapreco_descricao = '';
      } finally {
        this.$store.commit('InfoPedido/SET_LOADING_TABELA_PRECO', false);
      }
    },
    async removeItem(item) {
      await this.removeItemListTabelaItens(item.index);

      this.$root.$emit('item:removed', {
        referencia: item.item?.CodReferencia || item.item?.referencia,
      });

      this.$root.$emit('modal:sync-items');
    },
    async removeSubItem(row, subIndex) {
      const subItem = row.item.itens[subIndex];

      row.item.itens.splice(subIndex, 1);
      row.item.itens = row.item.itens.map(item => this.sanitizarMetadadosLinha(item));

      row.item.Qtde = row.item.itens.reduce((sum, item) => sum + item.pedidoItemQuantidade, 0);
      row.item.ValorTotal = row.item.itens.reduce((sum, item) => sum + (item.pedidoItemQuantidade * item.precoUnitario), 0);
      row.item.ValorTotalComImposto = row.item.itens.reduce(
        (sum, item) => sum + (Number(item.valorTotalComImposto ?? item.valorTotal) || 0), 0,
      );

      if (row.item.itens.length === 0) {
        await this.removeItem({ index: row.index });
      } else {
        this.$store.commit('intensPedido/UPDATE_TABELA_ITEM', {
          index: row.index,
          item: row.item,
        });

        this.$root.$emit('subitem:removed', {
          referencia: row.item.CodReferencia || row.item.referencia,
          item_id: subItem.itemId,
          des_cor: subItem.des_cor,
          tamanho: subItem.desc_tamanho,
        });
      }
    },
    validarRepresentanteSelecionado() {
      if (this.representanteBudgetId) return true;
      this.show = false;
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Representante não informado',
          text: 'Selecione o representante nas condições do pedido antes de salvar.',
          icon: 'AlertCircleIcon',
          variant: 'danger',
        },
      });
      return false;
    },
    async onSubmitRascunho() {
      if (!this.validarRepresentanteSelecionado()) return;
      this.show = true;

      const infoFormData = this.$store.getters['InfoPedido/GET_FORM_INFO_PEDIDO'];

      if (!infoFormData.cliente || !infoFormData.cliente.clienteid) {
        this.show = false;
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erro',
            text: 'Cliente não identificado. Por favor, selecione um cliente válido.',
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        });
        return;
      }

      const processarDataEntrega = () => {
        const dataPrevistaEntrega = this.formInfoPedido.enderecoEntrega.dataPrevistaEntrega
          || infoFormData.enderecoEntrega?.dataPrevistaEntrega;

        if (!dataPrevistaEntrega) {
          return this.calcularDataEntregaPadrao();
        }

        // Converte para formato ISO se estiver no formato DD/MM/YYYY
        if (typeof dataPrevistaEntrega === 'string' && dataPrevistaEntrega.includes('/')) {
          const [dia, mes, ano] = dataPrevistaEntrega.split('/');
          return `${ano}-${mes}-${dia}`;
        }

        // Se já estiver no formato ISO (YYYY-MM-DD), retorna como está
        if (typeof dataPrevistaEntrega === 'string' && dataPrevistaEntrega.includes('-')) {
          return dataPrevistaEntrega;
        }

        return this.calcularDataEntregaPadrao();
      };

      // Aplica regra rigorosa: nunca aceitar data passada
      const dataEntregaProcessada = this.clampPastDateISO(processarDataEntrega());

      const tipopedidoid = infoFormData.tipoPedido?.tipopedidoid
        || infoFormData.tipoPedidoCliente?.tipopedidoid
        || this.getFormData.dataCapaPedido.tipopedidoid
        || 1;

      const payload = {
        clienteid: infoFormData.cliente.clienteid,
        tipopedidoid,
        ...(this.isPedidoDoacaoAtual && this.transporteId ? { transportadoraid: String(this.transporteId) } : {}),
        ...(this.isPedidoDoacaoAtual && this.enderecoAlternativo ? {
          pedidoentregaendereco: this.enderecoAlternativo.endereco,
          pedidoentreganumero: this.enderecoAlternativo.numero,
          pedidoentregacomplemento: this.enderecoAlternativo.complemento,
          pedidoentregabairro: this.enderecoAlternativo.bairro,
          pedidoentregacidade: this.enderecoAlternativo.cidade,
          pedidoentregauf: this.enderecoAlternativo.uf,
          pedidoentregacep: this.enderecoAlternativo.cep,
        } : {}),
        condicaopagamentoid: infoFormData.condicaoPagamento?.condicaopagamentoid || this.getFormData.dataCapaPedido.condicaopagamentoid,
        // naturezaoperacaoid: infoFormData.cliente.naturezaoperacaoid || this.getFormData.dataCapaPedido.naturezaoperacaoid,
        naturezaoperacaoid: this.resolveNaturezaOperacao(infoFormData),
        tabelaprecoid: infoFormData.tabelaPreco?.tabelapreco_id || this.getFormData.dataCapaPedido.tabelaprecoid,
        pedidoobservacoes: infoFormData.observacao || this.getFormData.dataCapaPedido.observacoes,
        pedidourgente: false,
        // pedidodataentrega: infoFormData.enderecoEntrega?.dataPrevistaEntrega || this.getFormData.enderecoEntrega.dataPrevistaEntrega,
        pedidodataentrega: dataEntregaProcessada,
        // pedidodataentregaprevista: infoFormData.enderecoEntrega?.dataPrevistaEntrega || this.getFormData.enderecoEntrega.dataPrevistaEntrega,
        pedidodataentregaprevista: dataEntregaProcessada,
        pedidovalortotal: this.getTotalPedido,
        tipoenderecoid: infoFormData.enderecoEntrega?.tipoenderecoid || this.getFormData.enderecoEntrega?.tipoenderecoid || null,
        pedidooccliente: infoFormData.numeroPedidoOrderCompra || this.getFormData.dataCapaPedido.nr_oc || '',
        pedidoconsumidorfinal: true,
        pedidoprioridade: infoFormData.prioridadesPedido || this.getFormData.dataCapaPedido.prioridade_pedido || 1,
        canalvendaid: infoFormData.cliente.canal_venda_id || this.getFormData.dataCapaPedido.canalvendaid || '',
        cod_priori: infoFormData.prioridadesPedido || this.getFormData.dataCapaPedido.prioridade_pedido || 1,
        representanteid: this.representanteBudgetId,
        estabelecimentoid: infoFormData.estabelecimento?.estabelecimentoid || this.getFormData.dataCapaPedido.estabelecimentoid,
        itemsPedido: this.getListTabelaItens.map((item) => ({
          ...item,
          PrecoComImposto: item.PrecoComImposto || item.precoComImposto || 0,
          BaseIcms: item.BaseIcms || item.baseIcms || item.base_icms || 0,
          ValorIcms: item.ValorIcms || item.valorIcms || item.valor_icms || 0,
          itens: item.itens.map((subItem) => ({
            ...subItem,
            precoComImposto: subItem.precoComImposto || subItem.preco_com_imposto || 0,
            baseIcms: subItem.baseIcms || subItem.base_icms || 0,
            valorIcms: subItem.valorIcms || subItem.valor_icms || 0,
            valorTotalComImposto: subItem.valorTotalComImposto || 0,
            naturezaoperacaoidimposto: subItem.naturezaoperacaoidimposto || subItem.natureza_operacao_id_imposto || 0,
          })),
        })),
      };

      console.log('Payload de envio do pedido:', payload);

      try {
        const response = await slsPedidosService.finalizarRascunhoOperacao(payload);
        try {
          const draftId = String(response?.data?.data?.pedidoid || Date.now());
          const draft = {
            id: draftId,
            createdAt: Date.now(),
            updatedAt: Date.now(),
            infoPedidoSnapshot: infoFormData,
            itens: this.getListTabelaItens,
            total: this.getTotalPedido,
          };

          const indexKey = 'pedido_drafts_index';
          const currentIndex = JSON.parse(localStorage.getItem(indexKey) || '[]');
          const withoutThis = currentIndex.filter((d) => String(d.id) !== draftId);
          const meta = {
            id: draftId,
            createdAt: draft.createdAt,
            updatedAt: draft.updatedAt,
            cliente: {
              id: infoFormData?.cliente?.clienteid,
              nome: infoFormData?.cliente?.clienterazaosocial,
              iderp: infoFormData?.cliente?.clienteiderp,
            },
            representante: {
              id: this.representanteBudgetId,
              nome: this.getFormData?.dataCapaPedido?.representantenome,
            },
            tabelaprecoid: infoFormData?.tabelaPreco?.tabelapreco_id || null,
            condicaopagamentoid: infoFormData?.condicaoPagamento?.condicaopagamentoid || null,
            total: this.getTotalPedido,
          };

          localStorage.setItem(`pedido_draft_${draftId}`, JSON.stringify(draft));
          localStorage.setItem(indexKey, JSON.stringify([...withoutThis, meta]));
          localStorage.setItem('activeDraftId', draftId);
        } catch (e) {
          console.warn('Falha ao persistir snapshot do rascunho localmente:', e);
        }

        this.show = false;
        Swal.fire({
          title: 'Rascunho Salvo com Sucesso!',
          html: `Seu rascunho foi salvo com sucesso! Número do Rascunho: <strong>#${response.data.data.pedidoid}</strong>`,
          icon: 'success',
          confirmButtonText: 'OK',
        }).then(() => {
          this.resetBoletoPara15Dias();
          // this.clearCreatePedido();
          this.$store.dispatch('intensPedido/clearPedidoData');
          this.$router.push({ name: 'pedidos-vendas' });
        });
      } catch (error) {
        this.show = false;
        Swal.fire({
          title: error.response?.data?.title || 'Erro',
          text: error.response?.data?.message || 'Ocorreu um erro ao salvar o pedido',
          icon: 'error',
          confirmButtonText: 'OK',
        });
      } finally {
        this.show = false;
      }
    },
    getActiveDraftId() {
      try {
        return localStorage.getItem('activeDraftId') || null;
      } catch (e) {
        return null;
      }
    },
    shouldRestoreDraft() {
      const query = this.$route?.query || {};
      const params = this.$route?.params || {};

      const restoreFlag = String(query.restoreDraft || '').toLowerCase();
      const hasRestoreFlag = restoreFlag === '1' || restoreFlag === 'true';
      const hasDraftId = !!(query.draftId || params.draftId);

      return hasRestoreFlag || hasDraftId;
    },
    async loadActiveDraftIfAny() {
      if (!this.shouldRestoreDraft()) return;

      const activeId = this.getActiveDraftId();
      if (!activeId) return;
      try {
        const raw = localStorage.getItem(`pedido_draft_${activeId}`);
        if (!raw) return;
        const draft = JSON.parse(raw);
        if (draft && Array.isArray(draft.itens)) {
          await this.$store.dispatch('intensPedido/setListTabelaItens', draft.itens);
        }
        if (draft && draft.infoPedidoSnapshot) {
          this.$root.$emit('info-pedido:updated', draft.infoPedidoSnapshot);
        }
      } catch (e) {
        console.warn('Não foi possível restaurar o rascunho ativo:', e);
      }
    },
    async onSubmit() {
      if (!this.validarRepresentanteSelecionado()) return;
      if (this.show) return;
      this.show = true;

      // Doação (WD) sem estoque NÃO pode ser finalizada — só salva como
      // rascunho (onSubmitRascunho não passa por aqui). Checagem em lote;
      // se a consulta falhar/não responder, não bloqueia (fail-open).
      if (this.isPedidoDoacaoAtual && this.$store.getters['preferencias/controleEstoqueAtivo']) {
        try {
          const subItens = (this.getListTabelaItens || []).flatMap((g) => g.itens || []);
          const ids = [...new Set(subItens.map((i) => i.itemId || i.item_id).filter(Boolean))];
          if (ids.length) {
            // fresh: true — gate final não pode decidir por cache de sessão defasado.
            const saldos = await new SLSEstoqueService().consultarEstoque(ids, {
              fresh: true,
              tipoPedidoId: 'WD',
            });
            const qtdPorItem = {};
            subItens.forEach((i) => {
              const id = i.itemId || i.item_id;
              if (id) qtdPorItem[id] = (qtdPorItem[id] || 0) + (Number(i.pedidoItemQuantidade) || 0);
            });
            const semEstoque = ids.filter((id) => {
              const info = saldos && saldos[id];
              if (!info || info.quantidade === null || info.quantidade === undefined) return false;
              return Number(info.quantidade) < (qtdPorItem[id] || 0);
            });
            if (semEstoque.length) {
              this.show = false;
              const nomes = semEstoque.map((id) => {
                const it = subItens.find((i) => (i.itemId || i.item_id) === id);
                return `${id}${it && it.item_descricao ? ` - ${it.item_descricao}` : ''}`;
              });
              Swal.fire({
                title: 'Doação sem estoque',
                html: `Não é possível finalizar a doação: estoque insuficiente para:<br><b>${nomes.join('<br>')}</b><br><br>Você pode salvar o pedido como <b>rascunho</b> e finalizar quando houver estoque.`,
                icon: 'warning',
                confirmButtonText: 'Entendi',
                customClass: { confirmButton: 'btn btn-warning' },
                buttonsStyling: false,
              });
              return;
            }
          }
        } catch (e) {
          console.warn('[createPedidos] Falha na checagem de estoque da doação (segue sem bloquear):', e);
        }
      }

      const infoFormData = this.$store.getters['InfoPedido/GET_FORM_INFO_PEDIDO'];

      if (!infoFormData.cliente || !infoFormData.cliente.clienteid) {
        this.show = false;
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erro',
            text: 'Cliente não identificado. Por favor, selecione um cliente válido.',
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        });
        return;
      }

      // Endereço obrigatório para finalizar: ou o cadastro do cliente tem
      // UF+cidade, ou foi escolhido um endereço alternativo na aba Entrega.
      const altValido = this.isPedidoDoacaoAtual
        && this.enderecoAlternativo
        && String(this.enderecoAlternativo.uf || '').trim()
        && String(this.enderecoAlternativo.cidade || '').trim();
      if (!altValido && !enderecoEntregaValido(infoFormData.enderecoEntrega || infoFormData.cliente)) {
        this.show = false;
        Swal.fire({
          title: 'Endereço de entrega obrigatório',
          text: 'Este cliente não tem endereço completo cadastrado. Vá até a aba Entrega e selecione ou cadastre um endereço de entrega antes de salvar o pedido.',
          icon: 'warning',
          confirmButtonText: 'Entendi',
          customClass: { confirmButton: 'btn btn-warning' },
          buttonsStyling: false,
        });
        return;
      }

      // Toda a montagem do payload fica DENTRO do try: qualquer acesso a
      // propriedade ausente (ex.: canalVenda/enderecoEntrega nulos) lança de
      // forma síncrona e, se ficasse fora do try, o spinner (this.show) nunca
      // seria resetado -> "loading infinito". Aqui o catch/finally garante o reset.
      let pedidoPersistido = false;
      let pedidoIdPersistido = null;
      try {
        const formDataPedido = this.getFormData || {};
        const capaPedido = formDataPedido.dataCapaPedido || {};
        const gruposPedido = Array.isArray(this.getListTabelaItens)
          ? this.getListTabelaItens
          : [];
        const gruposInvalidos = gruposPedido.some(
          grupo => !grupo || !Array.isArray(grupo.itens) || grupo.itens.length === 0,
        );
        if (gruposPedido.length === 0 || gruposInvalidos) {
          throw new Error('Os itens do pedido estão incompletos. Recarregue a tela e adicione os produtos novamente.');
        }
        const copiarSemMetadadosUi = objeto => Object.keys(objeto || {}).reduce((copia, chave) => {
          if (!chave.startsWith('_')) {
            copia[chave] = objeto[chave];
          }
          return copia;
        }, {});

        const processarDataEntrega = () => {
          const dataPrevistaEntrega = this.formInfoPedido?.enderecoEntrega?.dataPrevistaEntrega
            || infoFormData.enderecoEntrega?.dataPrevistaEntrega;

          if (!dataPrevistaEntrega) {
            return this.calcularDataEntregaPadrao();
          }

          // Converte para formato ISO se estiver no formato DD/MM/YYYY
          if (typeof dataPrevistaEntrega === 'string' && dataPrevistaEntrega.includes('/')) {
            const [dia, mes, ano] = dataPrevistaEntrega.split('/');
            return `${ano}-${mes}-${dia}`;
          }

          // Se já estiver no formato ISO (YYYY-MM-DD), retorna como está
          if (typeof dataPrevistaEntrega === 'string' && dataPrevistaEntrega.includes('-')) {
            return dataPrevistaEntrega;
          }

          return this.calcularDataEntregaPadrao();
        };

        // Aplica regra rigorosa: nunca aceitar data passada
        const dataEntregaProcessada = this.clampPastDateISO(processarDataEntrega());

        const tipopedidoid = infoFormData.tipoPedido?.tipopedidoid
          || infoFormData.tipoPedidoCliente?.tipopedidoid
          || capaPedido.tipopedidoid
          || 1;

        // ID Nexus é opcional e exclusivo de doação, independentemente do perfil.
        const idNexusEnvio = String(infoFormData.idNexus || capaPedido.idnexus || '').trim();
        if (this.isPedidoDoacaoAtual && idNexusEnvio && !/^\d{6}$/.test(idNexusEnvio)) {
          Swal.fire({
            title: 'ID Nexus inválido',
            text: 'Se informar o ID Nexus, use exatamente 6 dígitos numéricos.',
            icon: 'warning',
            confirmButtonColor: '#28a745',
          });
          return;
        }

        const payload = {
          clienteid: infoFormData.cliente.clienteid,
          tipopedidoid,
          idnexus: this.isPedidoDoacaoAtual ? idNexusEnvio : '',
          ...(this.isPedidoDoacaoAtual && this.transporteId ? { transportadoraid: String(this.transporteId) } : {}),
          ...(this.isPedidoDoacaoAtual && this.enderecoAlternativo ? {
            pedidoentregaendereco: this.enderecoAlternativo.endereco,
            pedidoentreganumero: this.enderecoAlternativo.numero,
            pedidoentregacomplemento: this.enderecoAlternativo.complemento,
            pedidoentregabairro: this.enderecoAlternativo.bairro,
            pedidoentregacidade: this.enderecoAlternativo.cidade,
            pedidoentregauf: this.enderecoAlternativo.uf,
            pedidoentregacep: this.enderecoAlternativo.cep,
          } : {}),
          condicaopagamentoid: infoFormData.condicaoPagamento?.condicaopagamentoid || capaPedido.condicaopagamentoid,
          // naturezaoperacaoid: infoFormData.cliente.naturezaoperacaoid || this.getFormData.dataCapaPedido.naturezaoperacaoid,
          naturezaoperacaoid: this.resolveNaturezaOperacao(infoFormData),
          tabelaprecoid: infoFormData.tabelaPreco?.tabelapreco_id || capaPedido.tabelaprecoid,
          pedidoobservacoes: infoFormData.observacao || capaPedido.observacoes,
          pedidourgente: false,
          // pedidodataentrega: infoFormData.enderecoEntrega?.dataPrevistaEntrega || this.getFormData.enderecoEntrega.dataPrevistaEntrega,
          pedidodataentrega: dataEntregaProcessada,
          // pedidodataentregaprevista: infoFormData.enderecoEntrega?.dataPrevistaEntrega || this.getFormData.enderecoEntrega.dataPrevistaEntrega,
          pedidodataentregaprevista: dataEntregaProcessada,
          pedidovalortotal: this.getTotalPedido,
          tipoenderecoid: infoFormData.enderecoEntrega?.tipoenderecoid || formDataPedido.enderecoEntrega?.tipoenderecoid || null,
          pedidooccliente: infoFormData.numeroPedidoOrderCompra || capaPedido.nr_oc || '',
          pedidoconsumidorfinal: true,
          pedidoprioridade: infoFormData.prioridadesPedido || capaPedido.prioridade_pedido || 1,
          canalvendaid: infoFormData.canalVenda?.canal_venda_id
            || infoFormData.cliente?.canal_venda_id
            || infoFormData.cliente?.canalvendaid
            || capaPedido.canalvendaid
            || '',
          cod_priori: infoFormData.prioridadesPedido || capaPedido.prioridade_pedido || 1,
          representanteid: this.representanteBudgetId,
          estabelecimentoid: infoFormData.estabelecimento?.estabelecimentoid || capaPedido.estabelecimentoid,
          itemsPedido: gruposPedido.map((item) => ({
            ...copiarSemMetadadosUi(item),
            PrecoComImposto: item.PrecoComImposto || item.precoComImposto || 0,
            BaseIcms: item.BaseIcms || item.baseIcms || item.base_icms || 0,
            ValorIcms: item.ValorIcms || item.valorIcms || item.valor_icms || 0,
            itens: item.itens.map((subItem) => ({
              ...copiarSemMetadadosUi(subItem),
              precoComImposto: subItem.precoComImposto || subItem.preco_com_imposto || 0,
              baseIcms: subItem.baseIcms || subItem.base_icms || 0,
              valorIcms: subItem.valorIcms || subItem.valor_icms || 0,
              valorTotalComImposto: subItem.valorTotalComImposto || 0,
              naturezaoperacaoidimposto: subItem.naturezaoperacaoidimposto || subItem.natureza_operacao_id_imposto || 0,
            })),
          })),
        };

        JSON.stringify(payload);
        console.log('Payload de envio do pedido:', payload);

        const resultado = await finalizarPedidoOperacaoConfirmado(
          payload,
          data => slsPedidosService.finalizarPedidoOperacao(data),
        );
        if (!resultado) return;
        pedidoPersistido = true;
        pedidoIdPersistido = resultado.ids.join(', #');
        this.show = false;
        // Aviso: integração com TOTVS pausada para testes
        try {
          const totvsFlag = await getParametro('INTEGRACAO_TOTVS');
          if (String(totvsFlag) === '0' && this.$toast) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Aviso',
                text: 'A integração com o TOTVS está pausada para período de testes.',
                icon: 'AlertTriangleIcon',
                variant: 'warning',
              },
            });
          }
        } catch (avisoError) {
          console.warn('[createPedidos] Pedido salvo, mas o aviso da integração falhou:', avisoError);
        }
        Swal.fire({
          title: 'Pedido salvo com sucesso!',
          html: pedidoIdPersistido
            ? `Gravação confirmada. Pedido(s): <strong>#${pedidoIdPersistido}</strong>`
            : 'Seu pedido foi finalizado com sucesso. Consulte a lista de pedidos para ver o número gerado.',
          icon: 'success',
          confirmButtonText: 'OK',
        }).then(() => {
          this.resetBoletoPara15Dias();
          // this.clearCreatePedido();
          try {
            const activeId = this.getActiveDraftId();
            if (activeId) {
              localStorage.removeItem(`pedido_draft_${activeId}`);
              const indexKey = 'pedido_drafts_index';
              const currentIndex = JSON.parse(localStorage.getItem(indexKey) || '[]');
              const newIndex = currentIndex.filter((d) => String(d.id) !== String(activeId));
              localStorage.setItem(indexKey, JSON.stringify(newIndex));
              localStorage.removeItem('activeDraftId');
            }
          } catch (e) {
            console.warn('Falha ao limpar rascunho ativo após finalizar:', e);
          }
          this.$store.dispatch('intensPedido/clearPedidoData');
          this.$router.push({ name: 'pedidos-vendas' });
        });
      } catch (error) {
        this.show = false;
        if (pedidoPersistido) {
          console.error('[createPedidos] Pedido salvo, mas houve uma falha após a gravação:', error);
          Swal.fire({
            title: 'Pedido salvo com sucesso!',
            html: pedidoIdPersistido
              ? `O pedido <strong>#${pedidoIdPersistido}</strong> foi salvo, mas não foi possível atualizar a tela automaticamente.`
              : 'O pedido foi salvo, mas não foi possível atualizar a tela automaticamente. Consulte a lista de pedidos antes de tentar novamente.',
            icon: 'success',
            confirmButtonText: 'Ir para pedidos',
          }).then(() => {
            this.resetBoletoPara15Dias();
            this.$router.push({ name: 'pedidos-vendas' });
          });
          return;
        }
        if (error?.request && !error?.response) {
          const erroRede = error?.message || 'A resposta do servidor não foi recebida.';
          console.error(`[createPedidos] Resultado incerto após envio do pedido: ${erroRede}`);
          Swal.fire({
            title: 'Não foi possível confirmar o resultado',
            text: 'A solicitação pode ter sido recebida pelo servidor. Consulte a lista de pedidos antes de tentar novamente para evitar duplicidade.',
            icon: 'warning',
            confirmButtonText: 'Ir para pedidos',
          }).then(() => {
            this.$router.push({ name: 'pedidos-vendas' });
          });
          return;
        }
        const erroLocal = error?.message || String(error || '');
        console.error(`[createPedidos] Falha antes de concluir a gravação: ${erroLocal}`, error?.stack || '');
        Swal.fire({
          title: error.response?.data?.title || 'Erro',
          text: error.response?.data?.message
            || erroLocal
            || 'Ocorreu um erro ao salvar o pedido',
          icon: 'error',
          confirmButtonText: 'OK',
        });
      } finally {
        this.show = false;
      }
    },
    async voltar() {
      this.resetBoletoPara15Dias();
      this.clearCreatePedido();
      this.$router.push({ name: 'pedidos-vendas' });
    },
    // ===== Helpers de paridade com fluxo home/catálogo =====
    resolveNaturezaOperacao(infoFormData) {
      // 1) Prioriza naturezaoperacaoidimposto do 1º item (cálculo do TOTVS)
      const itens = this.getListTabelaItens || [];
      if (itens.length > 0 && itens[0].itens && itens[0].itens.length > 0) {
        const fromItem = itens[0].itens[0].naturezaoperacaoidimposto
          || itens[0].itens[0].natureza_operacao_id_imposto;
        if (fromItem) return fromItem;
      }
      // Sem retorno fiscal da TOTVS, recalcula para o endereço EFETIVO.
      return selecionarNaturezaFiscal(this.dadosCliente || infoFormData, {
        endereco: this.enderecoAlternativo || infoFormData?.enderecoEntrega || this.getFormData?.enderecoEntrega,
        estabelecimento: this.dadosCliente?.estabelecimento || { ufid: this.getFormData?.dataCapaPedido?.ufestabelecimento },
        cliente: this.dadosCliente?.cliente || this.getFormData?.dataCapaPedido,
      });
    },
    clampPastDateISO(dateISO) {
      // Recebe YYYY-MM-DD; se for passada, devolve hoje+7 também ISO
      try {
        if (!dateISO || typeof dateISO !== 'string') return this.calcularDataEntregaPadrao();
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const target = new Date(`${dateISO}T00:00:00`);
        if (Number.isNaN(target.getTime()) || target < today) {
          return this.calcularDataEntregaPadrao();
        }
        return dateISO;
      } catch (e) {
        return this.calcularDataEntregaPadrao();
      }
    },
    async fetchUltimoPedidoResumo() {
      const info = this.$store.getters['InfoPedido/GET_FORM_INFO_PEDIDO'] || {};
      const clienteid = info?.cliente?.clienteid;
      if (!clienteid) {
        this.ultimoPedidoResumo = null;
        this._adocaoFetchedFor = null;
        return;
      }
      if (this._adocaoFetchedFor === clienteid) return;
      this._adocaoFetchedFor = clienteid;
      this.isLoadingUltimoPedido = true;
      try {
        const client = new SLSAdocaoClient();
        const canalvendaid = info?.canalVenda?.canal_venda_id
          || info?.cliente?.canal_venda_id
          || info?.cliente?.canalvendaid
          || null;
        const resp = await client.getUltimoPedidoResumo(clienteid, canalvendaid);
        const data = resp?.data || null;
        this.ultimoPedidoResumo = (data && data.pedidoReferencia) ? data : null;
      } catch (err) {
        console.warn('[createPedidos] Falha ao buscar resumo do último pedido:', err);
        this.ultimoPedidoResumo = null;
      } finally {
        this.isLoadingUltimoPedido = false;
      }
    },
    abrirImportarCsv() {
      this.showImportarCsv = true;
    },
    abrirCatalogoCarrinhoInteligente() {
      // Importa os itens do último pedido do cliente direto neste pedido,
      // via modal "Auto completar pedido" (redirecionar pra home não importava
      // nada — o vendedor só via o catálogo).
      this.abrirAutoCompletar();
    },
    saveCurrentDraftSnapshot() {
      try {
        const itens = this.getListTabelaItens || [];
        const info = this.$store.getters['InfoPedido/GET_FORM_INFO_PEDIDO'] || {};
        // Só salva snapshot local enquanto há algo significativo
        if (!info?.cliente?.clienteid && itens.length === 0) return;

        let draftId = this.getActiveDraftId();
        if (!draftId) {
          draftId = `local_${Date.now()}`;
          try { localStorage.setItem('activeDraftId', draftId); } catch (e) { /* noop */ }
        }
        const draft = {
          id: draftId,
          createdAt: Date.now(),
          updatedAt: Date.now(),
          infoPedidoSnapshot: info,
          itens,
          total: this.getTotalPedido,
        };
        localStorage.setItem(`pedido_draft_${draftId}`, JSON.stringify(draft));
      } catch (e) {
        // Quota cheia ou serialização falhou; ignora silenciosamente
      }
    },
    scheduleAutoSaveDraft() {
      if (this._autoSaveDebounce) clearTimeout(this._autoSaveDebounce);
      this._autoSaveDebounce = setTimeout(() => {
        this.saveCurrentDraftSnapshot();
      }, 600);
    },
    async editarItem(item) {
      console.log('item', item);
      await this.$refs['editar-itens-pedido'].show({
        index: item.index,
        item: item.item.editar,
        subItens: item.item.itens,
      });
    },
  },
  computed: {
    picAtivo() {
      return this.$store.getters['preferencias/picAtivo'] === true;
    },
    podeBuscarPromocoes() {
      const capa = this.formInfoPedido.dataCapaPedido || {};
      return !!(capa.estabelecimentoid && capa.clienteid
        && capa.tabelaprecoid && capa.condicaopagamentoid);
    },
    // Tabela única (achatada): uma linha por item, sem sub-tabela "Mostrar
    // detalhes". Cada linha guarda somente os índices do grupo e do sub-item.
    fieldsFlat() {
      return [
        { key: '_marca', label: 'Marca', sortable: true },
        { key: '_referencia', label: 'Referência', sortable: true },
        { key: 'itemId', label: 'Código', sortable: true },
        { key: 'item_descricao', label: 'Descrição', sortable: true },
        { key: 'des_cor', label: 'Cor', sortable: true },
        { key: 'embalagem', label: 'Embalagem', sortable: true },
        { key: 'pedidoItemQuantidade', label: 'Quantidade', sortable: true },
        { key: 'precoComImposto', label: this.rotuloUnitarioVisual('Preço Unitario Final'), sortable: true },
        { key: 'valorTotalComImposto', label: 'Valor Total Final', sortable: true },
        { key: 'promo', label: 'Tipo Pedido', sortable: true },
        { key: 'excluir', label: 'Excluir', sortable: false },
      ];
    },
    // Achata os grupos (referência -> itens[]) em cópias próprias para exibição.
    // Os handlers persistem a alteração pelo Vuex usando os índices do grupo e
    // do sub-item, sem gravar metadados privados na estrutura do pedido.
    // Não anexa o grupo pai ao sub-item: essa referência criava o ciclo
    // grupo.itens -> subitem._grp -> grupo e quebrava o clone do Vuex.
    itensFlat() {
      const out = [];
      (this.getListTabelaItens || []).forEach((grupo, grpIndex) => {
        (grupo.itens || []).forEach((subitem, subIndex) => {
          const linha = this.sanitizarMetadadosLinha(subitem);
          linha._grpIndex = grpIndex;
          linha._subIndex = subIndex;
          linha._marca = grupo.DescricaoMarca;
          linha._referencia = grupo.DescricaoReferencia;
          linha._tipoPedido = grupo.tipoPedido;
          out.push(linha);
        });
      });
      return out;
    },
    rascunhoAtivo() {
      // Botão "Rascunho": preferência ativa + perfil autorizado e, quando
      // restrito a doação, apenas em pedidos WD.
      if (!this.$store.getters['preferencias/rascunhoPermitido']) return false;
      if (this.$store.getters['preferencias/rascunhoApenasDoacao'] && !this.isPedidoDoacaoAtual) return false;
      return true;
    },
    dataEntregaPadrao() {
      const date = new Date();
      date.setDate(date.getDate() + 7);

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');

      return `${year}-${month}-${day}`;
    },
    isInfoPedidoBloqueado() {
      return this.getListTabelaItens.length > 0;
    },
    isClienteFinal() {
      // Perfis do portal do cliente são isentos de ID Nexus.
      const perfilLogado = JSON.parse(localStorage.getItem('perfilLogado'));
      const nome = String(perfilLogado?.perfil_acesso_nome || '').trim().toLowerCase();
      return ['clientehanes', 'cliente', 'clientefinal', 'portalcliente'].includes(nome);
    },
    exibirBoletoPara15Dias() {
      return !this.isPedidoDoacaoAtual && podeSelecionarFormaPagamento();
    },
    isTabItensDisabled() {
      const info = this.$store.getters['InfoPedido/GET_FORM_INFO_PEDIDO'];
      return !(
        this.representanteBudgetId
        && info?.cliente?.clienteiderp
        && info?.tabelaPreco?.tabelapreco_id
        && info?.estabelecimento?.estabelecimentoid
      );
    },
    clienteIdErpSemZeros: {
      get() {
        if (!this.formInfoPedido.dataCapaPedido.clienteiderp) return '';
        return this.removeLeadingZeros(this.formInfoPedido.dataCapaPedido.clienteiderp);
      },
      set(value) {
        this.formInfoPedido.dataCapaPedido.clienteiderp = value;
      },
    },
    ...mapGetters('SLSRepresentante', {
      representante: 'selectedRepresentante',
    }),
    // Pedido de doação (WD): não há valor mínimo — nem aviso, nem bloqueio.
    isPedidoDoacaoAtual() {
      const infoPedido = this.$store.getters['InfoPedido/GET_FORM_INFO_PEDIDO'] || {};
      const tipo = this.getFormData?.dataCapaPedido?.tipopedidoid
        || infoPedido.tipoPedidoCliente?.tipopedidoid
        || infoPedido.tipoPedido?.tipopedidoid
        || this.getFormData?.dataCapaPedido?.tipopedidoid;
      return isPedidoDoacao(tipo);
    },
    representanteBudgetId() {
      // A capa é o campo visível da Operação. O contexto do catálogo pode
      // guardar outro representante, inclusive após troca de cliente/perfil.
      return this.getFormData?.dataCapaPedido?.representanteid || '';
    },
    avisosBudgetCarrinho() {
      const cats = (this.budgetCarrinho && this.budgetCarrinho.categorias) || {};
      return Object.values(cats).map(c => c && c.mensagem).filter(Boolean);
    },
    budgetCarrinhoBloqueia() {
      const cats = (this.budgetCarrinho && this.budgetCarrinho.categorias) || {};
      return Object.values(cats).some(c => c && c.bloqueia);
    },
    budgetMisto() {
      return !!(this.budgetCarrinho && this.budgetCarrinho.misto);
    },
    isPedidoCertificacaoAtual() {
      const infoPedido = this.$store.getters['InfoPedido/GET_FORM_INFO_PEDIDO'] || {};
      const tipo = this.getFormData?.dataCapaPedido?.tipopedidoid
        || infoPedido.tipoPedidoCliente?.tipopedidoid
        || infoPedido.tipoPedido?.tipopedidoid;
      return String(tipo || '').trim().toUpperCase() === 'WC';
    },
    pedidoMinimo() {
      if (this.isPedidoDoacaoAtual || this.isPedidoCertificacaoAtual) return true;
      const valorMinimo = parseFloat(this.dadosCliente.valorMinimoPedido || 0);
      const totalAtual = this.getTotalPedido;
      return totalAtual >= valorMinimo;
    },
    // Preferência BLOQUEAR_PEDIDO_MINIMO: quando ativa (padrão), pedidos abaixo
    // do mínimo são bloqueados; quando inativa, apenas avisamos na confirmação.
    bloqueioPedidoMinimoAtivo() {
      return this.$store.getters['preferencias/bloquearPedidoMinimo'];
    },
    ...mapGetters('InfoPedido', {
      getFormInfoPedido: ' GET_FORM_INFO_PEDIDO',
      getLoadingRepresentante: 'GET_LOADING_REPRESENTANTE',
      getLoadingCondPagamento: 'GET_LOADING_COND_PAGAMENTO',
      getOptionsCondPagamento: 'GET_OPTIONS_CONDICAO_PAGAMENTO',
    }),
    ...mapGetters('intensPedido', {
      getFormData: 'getFormData',
      getIsLoadingCapaPedido: 'getIsLoadingCapaPedido',
      getIsLoadingCliente: 'getIsLoadingCliente',
      getListTabelaItens: 'getlistarTabelaItens',
      getTotalPedido: 'getTotalPedido',
      getItemsPedidosArray: 'getItemsPedidosArray',
    }),
    ...mapGetters('PicStore', {
      loadingPic: 'GET_LOADING',
      IS_EXIST_PIC: 'IS_EXIST_PIC',
      picSelected: 'GET_PIC_SELECTED_OPERACAO',
    }),
    isRepresentanteDisabled() {
      return this.isClienteFinal && this.representantesCount === 1;
    },
    isClienteDisabled() {
      return this.isClienteFinal && this.clientesCount === 1
        || this.formInfoPedido.dataCapaPedido.representantenome === '';
    },
    disabledInputTabelaPreco() {
      const optionsTabelaPreco = this.$store.getters['InfoPedido/GET_OPTIONS_TABELA_PRECO'] || [];
      const tabelasPrecoSLS = this.$store.getters['SLSTabelapreco/tabelaprecos'] || [];

      const opcoes = optionsTabelaPreco.length > 0 ? optionsTabelaPreco : tabelasPrecoSLS;
      return opcoes.length === 1 || this.formInfoPedido.dataCapaPedido.clienteiderp === '';
    },
    disabledInputCondPagamento() {
      const infoPedido = this.$store.getters['InfoPedido/GET_OPTIONS_CONDICAO_PAGAMENTO'] || [];
      const condPagamentos = this.$store.getters['SLSCondicaoPagamento/GET_COND_PAGTOS'] || [];

      const opcoes = infoPedido.length > 0 ? infoPedido : condPagamentos;
      return opcoes.length === 1 || this.formInfoPedido.dataCapaPedido.clienteiderp === '';
    },
    formInfoPedido: {
      get() {
        return this.getFormData;
      },
      set(value) {
        this.$store.commit('intensPedido/SET_CAPA_PEDIDO', value);
      },
    },
  },
  async mounted() {
    this.verificarPerfilUsuario();
    this.clearCreatePedido();
    this.agendarChecagemBudget();
    await slsEsPrioriService.selectPrioridadePedido();

    this.$watch(
      () => this.$store.getters['InfoPedido/GET_FORM_INFO_PEDIDO'],
      (newFormData) => {
        if (newFormData.cliente && newFormData.cliente.clienteid) {
          this.dadosCliente = {
            ...this.dadosCliente,
            cliente: newFormData.cliente,
            estabelecimento: newFormData.estabelecimento,
            tabelaPreco: newFormData.tabelaPreco,
            condicaoPagamento: newFormData.condicaoPagamento,
            enderecoEntrega: newFormData.enderecoEntrega,
            valorMinimoPedido: newFormData.valorMinimoPedido || 0,
          };

          this.$store.commit('intensPedido/SET_IFO_CLIENTE', this.dadosCliente);

          this.$store.commit('intensPedido/SET_CAPA_PEDIDO', {
            ...this.formInfoPedido.dataCapaPedido,
            clienteid: newFormData.cliente.clienteid,
            clienteiderp: newFormData.cliente.clienteiderp,
            cliente_nome: newFormData.cliente.clienterazaosocial,
            clientenomeabreviado: newFormData.cliente.clientenomeabreviado,
            clienteisentoie: newFormData.cliente.clienteisentoie,
            condicaopagamentoid: newFormData.condicaoPagamento?.condicaopagamentoid || '',
            condicaopagamentodescricao: newFormData.condicaoPagamento?.condicaopagamentodescricao || '',
            tabelaprecoid: newFormData.tabelaPreco?.tabelapreco_id || '',
            tabelapreco_descricao: newFormData.tabelaPreco?.tabelapreco_descricao || '',
            naturezaoperacaoid: newFormData.naturezaOperacao?.naturezaoperacaoid || '',
            ufestabelecimento: newFormData.estabelecimento?.ufid || newFormData.estabelecimento?.ufestabelecimento || '',
            clientenatoperinterna: newFormData.cliente?.clientenatoperinterna || '',
            clientenatoperexterna: newFormData.cliente?.clientenatoperexterna || '',
            canalvendaid: newFormData.cliente?.canal_venda_id || '',
            estabelecimentoid: newFormData.estabelecimento?.estabelecimentoid || '',
            estabelecimentorazaosocial: newFormData.estabelecimento?.estabelecimentorazaosocial || '',
          });

          if (newFormData.enderecoEntrega) {
            this.$store.commit('intensPedido/SET_ENDERECO_ENTREGA', {
              ...newFormData.enderecoEntrega,
              clienteid: newFormData.cliente.clienteid,
            });
          }

          console.log('Dados do cliente atualizados do InfoPedido:', this.dadosCliente);
          console.log('Valor mínimo do pedido:', this.dadosCliente.valorMinimoPedido);
        }
      },
      { deep: true },
    );

    this.$root.$on('representante:changed', async (representanteId) => {
      console.log('Representante alterado:', representanteId);

      this.$store.commit('intensPedido/SET_CAPA_PEDIDO', {
        ...this.formInfoPedido.dataCapaPedido,
        clienteiderp: '',
        cliente_nome: '',
        clientenomeabreviado: '',
        clienteisentoie: '',
        condicaopagamentoid: '',
        condicaopagamentodescricao: '',
        tabelaprecoid: '',
        tabelapreco_descricao: '',
        naturezaoperacaoid: '',
        naturezaoperacaodescricao: '',
        canalvendaid: '',
        canal_venda_descricao: '',
        estabelecimentoid: '',
        estabelecimentorazaosocial: '',
      });

      this.$store.commit('InfoPedido/SET_OPTIONS_TABELA_PRECO', []);
      this.$store.commit('InfoPedido/SET_OPTIONS_COND_PAGAMENTO', []);
      this.$store.commit('SLSCondicaoPagamento/SET_CURRENT_COND_PAGTO', []);
      this.$store.commit('PicStore/RESET_PIC_SELECTION');
    });

    this.$root.$on('condpagto:selected', (condPagto) => {
      this.$store.commit('intensPedido/SET_CAPA_PEDIDO', {
        ...this.formInfoPedido.dataCapaPedido,
        condicaopagamentoid: condPagto.condicaopagamentoid,
        condicaopagamentodescricao: condPagto.condicaopagamentodescricao,
      });

      this.$store.commit('PicStore/SET_FILTERS_CONDICAOPAGAMENTO_ID', condPagto.condicaopagamentoid);
      picService.getPicPedidos();
    });

    this.$root.$on('cliente:selected-from-modal', (clienteData) => {
      this.dadosCliente = clienteData;
      console.log('Dados do cliente atualizados do modal:', this.dadosCliente);
    });

    if (!this.formInfoPedido.enderecoEntrega.dataPrevistaEntrega) {
      const defaultDate = new Date();
      defaultDate.setDate(defaultDate.getDate() + 7);

      const day = String(defaultDate.getDate()).padStart(2, '0');
      const month = String(defaultDate.getMonth() + 1).padStart(2, '0');
      const year = defaultDate.getFullYear();

      const formattedDate = `${day}/${month}/${year}`;

      this.$store.commit('intensPedido/SET_ENDERECO_ENTREGA', {
        ...this.formInfoPedido.enderecoEntrega,
        dataPrevistaEntrega: formattedDate,
      });
    }

    // Restaurar rascunho ativo (se houver)
    await this.loadActiveDraftIfAny();

    // Carrinho Inteligente: busca resumo do último pedido quando cliente disponível
    this.fetchUltimoPedidoResumo();

    // Auto-save de rascunho local: dispara quando itens ou form mudarem
    this.$watch(
      () => [this.getListTabelaItens, this.formInfoPedido],
      () => {
        this.scheduleAutoSaveDraft();
        this.fetchUltimoPedidoResumo();
      },
      { deep: true },
    );
  },
  beforeDestroy() {
    this.budgetCheckSeq += 1;
    if (this.budgetCheckTimer) clearTimeout(this.budgetCheckTimer);
    if (this.unwatchEnderecoAlternativoStore) this.unwatchEnderecoAlternativoStore();
    this.resetBoletoPara15Dias();
    this.$root.$off('condpagto:selected');
    this.$root.$off('cliente:selected-from-modal');
    if (this._autoSaveDebounce) {
      clearTimeout(this._autoSaveDebounce);
      this._autoSaveDebounce = null;
    }

    // console.log('Componente está prestes a ser desmontado');

    this.$store.commit('PicStore/SET_PIC', {
      pic_genericas: [],
      pic_cliente: [],
    });
  },
};
</script>

<style lang="scss" scoped>
.quantity-control {
  display: flex;
  align-items: center;
  justify-content: center;

  .btn-quantity {
    padding: 0.15rem 0.4rem;
    line-height: 1;
  }

  .quantity-value {
    min-width: 30px;
    text-align: center;
    font-weight: 600;
  }
}
</style>
